// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:36:34.914Z
// Property: Sugarberry Apartments (ID: 6767906449165627)
// Collections: 24 amenities, 4 floorplans (live), 30 photos, 75 POIs, 2 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165627",
  "property_external_id": "lr43rpf",
  "property_zillow_url": "https://www.zillow.com/b/sugarberry-tulsa-ok-5XhzQV/",
  "property_apartments_url": "https://www.apartments.com/sugarberry-apartments-tulsa-ok/lr43rpf/",
  "property_google_business_url": "https://www.google.com/maps/place/Sugarberry+Apartments/data=!4m2!3m1!1s0x0:0x4d7fe03bc08980fb?sa=X&ved=2ahUKEwivjorZ_7ySAxVcJUQIHQjiApMQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "sugarberry-apartments",
  "property_name": "Sugarberry Apartments",
  "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/sugarberry/",
  "property_domain": null,
  "property_address": "10902 East 61st Street",
  "property_full_address": "10902 East 61st Street, Tulsa, OK, 74133",
  "property_address_1": "10902 East 61st Street",
  "property_address_2": null,
  "property_address_city": "Tulsa",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74133",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": "South Tulsa",
  "property_address_latitude": "36.0734",
  "property_address_longitude": "-95.8542",
  "property_email": "sugarberry@caseusa.com",
  "property_phone": "(539) 424-0515",
  "property_call_tracking_phone": "844-405-1448",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Sugarberry Apartments in Tulsa, your ideal living space awaits. Choose from one, two, or three-bedroom floor plans, all featuring modern amenities like a refreshing pool, fitness center, and pet-friendly play areas. With a welcoming clubhouse and scenic trails, your perfect home is just a tour away! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Sugarberry Apartments, your ideal urban retreat in the heart of Tulsa, Oklahoma. With a variety of thoughtfully designed floor plans, including cozy one-bedroom, spacious two-bedroom, and spacious three-bedroom apartments, we cater to every lifestyle and need. Each residence features modern amenities such as air conditioning, high-speed internet access, and plush walk-in closets to enhance your living experience.\n\nAt Sugarberry Apartments, we prioritize your comfort and convenience. Dive into relaxation at our sparkling swimming pool, or maintain your fitness goals in our state-of-the-art fitness center. For family fun, let the kids enjoy our playground while adults engage in friendly competition on the basketball and tennis courts. Our community also boasts serene walking and biking trails, perfect for leisurely strolls or invigorating exercise.\n\nWe understand the importance of service, which is why our dedicated property manager and on-site maintenance team are available to meet your needs promptly. Enjoy the ease of modern living with laundry facilities, package services, and additional perks such as a business center, clubhouse, and courtyards designed for relaxation. Bring your furry friends along to enjoy the pet play area!\n\nSugarberry Apartments is a smoke-free community that combines comfort, convenience, and an inviting atmosphere. With features like an outdoor grilling and picnic area, you’ll love spending time outdoors.\n\nDon’t miss your chance to join our vibrant community! Find your new home today—explore our availability or schedule a tour to see why Sugarberry Apartments is the perfect place to call home!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-8578-7114-a2f3-bc0b813bc25d.webp",
  "property_featured_image_media": {
    "alt_text": "Swimming pool with lounge chairs and umbrella at an apartment complex.",
    "public_id": "019cfb47-8578-7114-a2f3-bc0b813bc25d",
    "storage_key": "property/6767906449165627/019cfb47-8578-7114-a2f3-bc0b813bc25d.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "304",
  "property_year_built": "1983",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.02631578947368",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Cats and dogs allowed, no weight limit. Maximum of two pets per unit.",
  "property_pet_policy_description": "Cats and dogs allowed, no weight limit. Maximum of two pets per unit. Pet rent: $30 per pet per month. Non‑refundable pet fee: $500 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://sugarberryapartmentstulsa.securecafe.com/onlineleasing/sugarberry-apartments/floorplans.aspx",
  "property_resident_portal_url": "https://sugarberryapartmentstulsa.securecafe.com/residentservices/sugarberry-apartments/userlogin.aspx",
  "property_apply_now_url": "https://sugarberryapartmentstulsa.securecafe.com/onlineleasing/sugarberry-apartments/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-8538-76fc-8119-4e937eab78f5.webp",
  "property_primary_logo_media": {
    "alt_text": "Sugarberry Apartment Homes logo",
    "public_id": "019cfb47-8538-76fc-8119-4e937eab78f5",
    "storage_key": "property/6767906449165627/019cfb47-8538-76fc-8119-4e937eab78f5.webp",
    "width": 389,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb48-723f-7065-9576-e71f7823cb36.webp",
  "property_secondary_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb48-723f-7065-9576-e71f7823cb36",
    "storage_key": "property/6767906449165627/019cfb48-723f-7065-9576-e71f7823cb36.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb48-8145-75cd-9289-3f29b360de13.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Sugarberry Apartment Homes logo with a laurel branch.",
    "public_id": "019cfb48-8145-75cd-9289-3f29b360de13",
    "storage_key": "property/6767906449165627/019cfb48-8145-75cd-9289-3f29b360de13.webp",
    "width": 389,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb48-91d4-756f-a7c5-9cb2c02e4974.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Sugarberry Apartment Homes logo with branches above text.",
    "public_id": "019cfb48-91d4-756f-a7c5-9cb2c02e4974",
    "storage_key": "property/6767906449165627/019cfb48-91d4-756f-a7c5-9cb2c02e4974.webp",
    "width": 389,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#182b17",
  "property_secondary_color": "#000000",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "725 - 1200",
  "property_sqft_min": "725",
  "property_sqft_max": "1200",
  "property_price_range": "929 - 1499",
  "property_price_min": "929",
  "property_price_max": "1499",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/SugarberryTulsa/posts/discover-your-perfect-space-at-sugarberry-apartmentsschedule-your-tour-today-wit/1435747155218883/",
  "property_instagram_url": "https://www.instagram.com/sugarberryapartmentstulsa/?hl=en",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ2d-16lSMtocR-4CJwDvgf00",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_near=sonoma-grande-apartments-tulsa-3",
  "property_tiktok_url": "https://www.tiktok.com/@sugarberryaptstulsa?_t=8lPyuAv42al&_r=1",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Sugarberry Apartments",
  "property_home_romance_title": "Embrace the Joy of Living at Our Charming Community",
  "property_home_amenities_blurb": "Welcome to Sugarberry Apartments in Tulsa, Oklahoma, where comfort and convenience meet. Choose from spacious one to three-bedroom floor plans, and enjoy top-tier amenities such as a refreshing pool, state-of-the-art fitness center, and scenic walking trails. Our community is designed for every lifestyle—live life sweetly at Sugarberry.",
  "property_home_floorplans_blurb": "Welcome to Sugarberry Apartments, where comfort meets style in the heart of Tulsa, Oklahoma. Whether you're seeking a cozy one-bedroom or a spacious three-bedroom, each thoughtfully designed floor plan is ready to welcome you home. Browse our available apartment homes and find your ideal sanctuary today!",
  "property_home_gallery_blurb": "Welcome to Sugarberry Apartments in Tulsa, Oklahoma, where community and comfort converge. Choose from spacious one, two, or three-bedroom floor plans, complemented by a wealth of amenities like a refreshing pool, a well-equipped fitness center, and serene walking trails. Picture yourself living here—your ideal home awaits!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Tulsa, Sugarberry Apartments offers one, two, and three-bedroom floor plans designed for your comfort. Immerse yourself in a vibrant neighborhood filled with local favorites and hidden gems. Uncover the unique charm surrounding your new home—whether it's dining, parks, or entertainment, it's all just steps away!",
  "property_home_reviews_blurb": "At Sugarberry Apartments in Tulsa, we pride ourselves on creating a welcoming community where residents feel right at home. As one resident noted, “The staff is wonderful and always around when needed.” With a supportive team and a host of nearby amenities, your ideal living experience awaits!",
  "property_neighborhood_blurb": "At Sugarberry Apartments in Tulsa, Oklahoma, enjoy the perfect blend of comfort and convenience. Nestled near esteemed educational institutions like Oral Roberts University and Union High School, our community offers easy access to enriching opportunities. See what's around our community and explore local favorites and nearby points of interest.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Sugarberry Apartments in Tulsa, unwind by the sparkling pool or energize at the fitness center. Enjoy spacious one, two, or three-bedroom floor plans complete with modern comforts. With pet-friendly spaces, walking trails, and a vibrant clubhouse, your perfect lifestyle awaits. Dive into our amenities today that elevate everyday living!",
  "property_applynow_blurb": "At Sugarberry Apartments in Tulsa, Oklahoma, embrace the perfect blend of comfort and convenience. Choose from spacious one, two, and three-bedroom floor plans while enjoying top-tier amenities like a sparkling pool, onsite fitness center, and pet-friendly areas. Your new home awaits—lease online today!",
  "property_contactus_blurb": "At Sugarberry Apartments in Tulsa, Oklahoma, diverse floor plans await to fit your lifestyle—choose from cozy one-bedroom retreats to spacious three-bedroom homes. Embrace comfort and community where convenience meets charm. Have questions? Our leasing team is ready to assist you, ensuring you find your perfect space today!",
  "property_faqs_blurb": "At Sugarberry Apartments in Tulsa, Oklahoma, we offer thoughtfully designed one, two, and three-bedroom floor plans to fit your lifestyle. Dive into our FAQs page for insightful answers about our vibrant community and amenities, ensuring you find the perfect home nestled among the sweet charm of Sugarberry.",
  "property_floorplans_blurb": "At Sugarberry Apartments in Tulsa, Oklahoma, your ideal home awaits. Choose from our thoughtfully designed one, two, or three-bedroom floor plans, catering to every lifestyle. Delight in spacious living areas and modern amenities. Browse our available apartment homes and find the perfect fit for your vibrant life today!",
  "property_gallery_blurb": "At Sugarberry Apartments in Tulsa, Oklahoma, our vibrant community shines through stunning photo galleries. Imagine basking by the pool, enjoying a game on the courts, or unwinding in your modern one, two, or three-bedroom home. Picture yourself living here, where comfort meets convenience amidst lush walking trails and welcoming amenities!",
  "property_interactivemap_blurb": "Welcome to Sugarberry Apartments in Tulsa, Oklahoma, where comfort meets convenience. Choose from our thoughtfully designed one, two, or three-bedroom floor plans, and enjoy resort-style amenities like a sparkling pool, fitness center, and pet play area. Our interactive community map makes finding your perfect home easy and enjoyable!",
  "property_pets_blurb": "At Sugarberry Apartments in Tulsa, OK, your furry companions will feel right at home! With no weight limits and a welcoming policy for both cats and dogs, you can enjoy life with your beloved pets. Unleash happiness with our spacious units, perfect for every tail-wagging moment!",
  "property_referafriend_blurb": "At Sugarberry Apartments in Tulsa, Oklahoma, we believe that great friends make great neighbors. Whether you're seeking a cozy one-bedroom or a spacious three-bedroom, our diverse floor plans offer comfort and style. Share the joy of living here—refer a friend to join your vibrant community today!",
  "property_residentaccess_blurb": "At Sugarberry Apartments in Tulsa, Oklahoma, our thoughtfully designed one, two, and three-bedroom floor plans cater to your lifestyle. Experience seamless resident access through our portal, where you can effortlessly pay rent, schedule maintenance, and manage your home with just a few clicks. Your convenience awaits!",
  "property_reviews_blurb": "At Sugarberry Apartments in Tulsa, our residents rave about the exceptional service and community spirit. One happy resident shared, “The staff is wonderful and always around when needed.” Experience a secure, friendly environment with quick maintenance and all the conveniences you desire. Join us and feel at home!",
  "property_created_at": "1753982392027",
  "property_scheduletour_blurb": "At Sugarberry Apartments in Tulsa, Oklahoma, our diverse floor plans—one, two, and three-bedroom options—cater to your unique lifestyle. Experience the vibrant community and cozy ambiance that make living here exceptional. Schedule a tour today and hear firsthand from our residents about their delightful experiences at Sugarberry!",
  "property_thankyou_blurb": "Thank you for reaching out! At Sugarberry Apartments in Tulsa, Oklahoma, we offer versatile one, two, and three-bedroom floor plans tailored to fit your lifestyle. Our team will be in touch shortly to help you find your ideal home sweet home in our vibrant community!",
  "property_virtualtours_blurb": "At Sugarberry Apartments in Tulsa, Oklahoma, a world of comfort awaits with beautifully designed one, two, and three-bedroom floor plans. Experience the perfect balance of style and functionality—your dream home is just a click away. Join us on a virtual tour and see what life can be like!",
  "property_copyright": "2025 All Rights Reserved. Sugarberry Apartments",
  "property_seo_title_home": "Sugarberry Apartments | Apartments in Tulsa, Oklahoma",
  "property_seo_description_home": "Experience comfort and community at Sugarberry Apartments in Tulsa! Choose from spacious one, two, or three-bedroom layouts with fantastic amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Tulsa, Oklahoma",
  "property_seo_description_floorplans": "Find your ideal space at Sugarberry Apartments in Tulsa! Choose from one, two, or three bedroom layouts that cater to your lifestyle. Browse our floor plans today!",
  "property_seo_title_amenities": "Amenities | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "\"Find your perfect home at Sugarberry Apartments in Tulsa, OK! Enjoy resort-style amenities and spacious floor plans designed for comfort and convenience.\"",
  "property_seo_title_gallery": "Gallery | Apartments in Tulsa, Oklahoma",
  "property_seo_description_gallery": "Capture life's best moments at Sugarberry Apartments in Tulsa! Dive into our vibrant photo gallery showcasing spacious floor plans and inviting amenities. ",
  "property_seo_title_virtualtours": "Virtual Tours | Sugarberry Apartments Apartments",
  "property_seo_description_virtualtours": "Step inside Sugarberry Apartments in Tulsa, OK! Take a virtual tour and envision your dream home with spacious one to three-bedroom floor plans tailored for you.",
  "property_seo_title_interactivemap": "Interactive Map | Sugarberry Apartments Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Sugarberry Apartments in Tulsa! Use our interactive map to explore one to three-bedroom floor plans and discover unmatched amenities!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tulsa, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood around Sugarberry Apartments in Tulsa, OK. Enjoy local favorites and nearby attractions that make every day an adventure!",
  "property_seo_title_contact": "Contact Us | Sugarberry Apartments",
  "property_seo_description_contact": "Reach out to the Sugarberry Apartments team in Tulsa! Whether you need info on our one, two, or three-bedroom floor plans, we're here to help with your inquiries.",
  "property_seo_title_faqs": "FAQs | Apartments in Tulsa, Oklahoma",
  "property_seo_description_faqs": "Get insights into Sugarberry Apartments in Tulsa! Our FAQs page answers everything you need to know about our diverse floor plans and premium amenities.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tulsa, Oklahoma",
  "property_seo_description_reviews": "\"Real experiences from our residents at Sugarberry Apartments in Tulsa. Hear why they love their spacious homes and vibrant amenities! Join our community today!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Tulsa, Oklahoma",
  "property_seo_description_applynow": "Experience vibrant living at Sugarberry Apartments in Tulsa! Choose from spacious 1, 2, or 3-bedroom floor plans with top-notch amenities. Secure your new home today!",
  "property_seo_title_residentaccess": "Resident Access | Sugarberry Apartments",
  "property_seo_description_residentaccess": "Unlock your Sugarberry Apartments experience! Log in to your resident portal for easy rent payment, maintenance requests, and community updates in Tulsa, OK.",
  "property_seo_title_referafriend": "Refer A Friend | Sugarberry Apartments",
  "property_seo_description_referafriend": "Refer a friend to Sugarberry Apartments in Tulsa! Great friends create a vibrant community. Share the love and enjoy life together in your new home!",
  "property_seo_title_scheduletour": "Schedule a Tour | Sugarberry Apartments",
  "property_seo_description_scheduletour": "Experience the charm of Sugarberry Apartments in Tulsa. Schedule a tour today and find your perfect home amidst lush landscapes and modern comforts!",
  "property_seo_title_privacy": "Privacy Policy | Sugarberry Apartments",
  "property_seo_description_privacy": "Your privacy matters at Sugarberry Apartments! Discover how we protect your personal information while you enjoy our vibrant Tulsa community. View our policy!",
  "property_seo_title_accessibility": "Website Accessibility | Sugarberry Apartments",
  "property_seo_description_accessibility": "At Sugarberry Apartments in Tulsa, we prioritize digital inclusion. Learn how our community ensures accessibility for all residents and visitors. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Sugarberry Apartments",
  "property_seo_description_sitemap": "Unravel the charm of Sugarberry Apartments in Tulsa! Navigate our sitemap for easy access to a vibrant community, amenities, and your future home.",
  "property_seo_title_thankyou": "Thank You | Sugarberry Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Sugarberry Apartments in Tulsa! We'll connect soon with the details you need to start your next chapter in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Tulsa, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865806286",
  "amenities": [
    {
      "id": "ec_23e4fdc4148d6c71642dcaea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127397154",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_60e37753af012ed55f2e9b7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127397156",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_79b3de9e20de1d9a29b37039",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127397157",
      "title": "Tennis Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6475dfd4b6831b4a5306939e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127397158",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d4906231148a8ad00af9546f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127397159",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09f422224ea349e2495b8e40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127397161",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8c4e0ebc9aa5105aeaeb9c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127397162",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5ffd6a44f0ea9180e4df109c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127397163",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e817e6521ac0b422e9db3bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127397164",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_064696c1eec6432a66abd116",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127397165",
      "title": "Onsite Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_34020850aa1132ae4a06396b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "128017288",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_15fc4634345b3a7fd089392c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "128042555",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f641393966ec9af2512c179c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127398610",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a4174c7b45179a771ad31b8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127398611",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fe4024c8f18c8e1cb7d42754",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127398612",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_95d767d82ca5b81aadf91e1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127398613",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5adabefb4c9819e4002d1bda",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127398614",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9171864296702be2e157d961",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127398615",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9c92c18b1958b6ba6f548d2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127398616",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_af44b3f2c749517b47e4b8d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127398617",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dcc2115fedf9211c3668c4bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127398618",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba28fc474e55b63090599441",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127398619",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1bab40ca28689bd15c473e95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127398620",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_343839bb86d75aace7416c1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "yardi",
      "external_id": "127398621",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_5be58d1e-98bc-4634-ade3-86955d92c520",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-f687-720e-b918-f643437fa8cc.webp",
      "image_media": {
        "alt_text": "Balcony with seating and plant overlooking trees and buildings.",
        "public_id": "01a01601-f687-720e-b918-f643437fa8cc",
        "storage_key": "property/6767906449165627/01a01601-f687-720e-b918-f643437fa8cc.webp",
        "width": 2049,
        "height": 3072
      },
      "title": "Community",
      "description": "Enjoy your morning coffee or evening relaxations on your private balcony, offering a serene view of the surrounding landscape.",
      "link": "",
      "alt_text": "Balcony with seating and plant overlooking trees and buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_064deed8-b8d9-4bbe-8ddd-abcd4c901355",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-f5ef-727d-8c86-41dadd081bd8.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets and granite countertops.",
        "public_id": "01a01601-f5ef-727d-8c86-41dadd081bd8",
        "storage_key": "property/6767906449165627/01a01601-f5ef-727d-8c86-41dadd081bd8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring dark wood cabinetry, granite countertops, and a breakfast nook with seating for two.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_35a13fda-4607-47e4-8b30-69b5832ac352",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-f15f-7608-9024-595f6cc98309.webp",
      "image_media": {
        "alt_text": "Bathroom with bathtub, toilet, and vanity",
        "public_id": "01a01601-f15f-7608-9024-595f6cc98309",
        "storage_key": "property/6767906449165627/01a01601-f15f-7608-9024-595f6cc98309.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and bright bathroom featuring a bathtub, toilet, and a spacious vanity with a sink and ample counter space.",
      "link": "",
      "alt_text": "Bathroom with bathtub, toilet, and vanity",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_21098aaa-cb90-4783-b9c2-7404a79b35d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-d251-712b-8251-cdf66c194420.webp",
      "image_media": {
        "alt_text": "Walk-in closet with shelving and hanging rods.",
        "public_id": "01a01601-d251-712b-8251-cdf66c194420",
        "storage_key": "property/6767906449165627/01a01601-d251-712b-8251-cdf66c194420.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring built-in shelving and ample hanging space for organized storage.",
      "link": "",
      "alt_text": "Walk-in closet with shelving and hanging rods.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c6d4d198-ec02-410d-aa5f-10712866809a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-d0e4-7306-9f4a-80db61f3339a.webp",
      "image_media": {
        "alt_text": "Stack of white washer and dryer machines with a shelf above holding laundry supplies.",
        "public_id": "01a01601-d0e4-7306-9f4a-80db61f3339a",
        "storage_key": "property/6767906449165627/01a01601-d0e4-7306-9f4a-80db61f3339a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish laundry room featuring white washer and dryer appliances, complemented by a shelf with neatly folded towels, baskets, and laundry essentials.",
      "link": "",
      "alt_text": "Stack of white washer and dryer machines with a shelf above holding laundry supplies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_76ee47e3-c806-4417-93fd-e3d0986116df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-d0a3-720f-9459-b86218a1e7c3.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and walk-in closet.",
        "public_id": "01a01601-d0a3-720f-9459-b86218a1e7c3",
        "storage_key": "property/6767906449165627/01a01601-d0a3-720f-9459-b86218a1e7c3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious bedroom featuring a plush queen-size bed, ample closet space, and a serene ambiance. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a99ba4ce-88d2-486e-8d4a-8b51fce2a84d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-d083-712b-8118-3d7cce862c46.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four wooden chairs, decorated with botanical art.",
        "public_id": "01a01601-d083-712b-8118-3d7cce862c46",
        "storage_key": "property/6767906449165627/01a01601-d083-712b-8118-3d7cce862c46.webp",
        "width": 2052,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Stylish dining area featuring a round table, comfortable wooden chairs, and tasteful botanical wall art. Perfect for intimate meals.",
      "link": "",
      "alt_text": "Dining area with a round table and four wooden chairs, decorated with botanical art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d118dfc7-ce86-4150-bb42-79e3c3f50f4a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-36ee-72b5-b48c-cba00d3dc711.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four chairs, featuring botanical art on the wall.",
        "public_id": "01a01601-36ee-72b5-b48c-cba00d3dc711",
        "storage_key": "property/6767906449165627/01a01601-36ee-72b5-b48c-cba00d3dc711.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy dining nook with a stylish round table, four woven chairs, and decorative botanical art, perfect for intimate meals.",
      "link": "",
      "alt_text": "Dining area with a round table and four chairs, featuring botanical art on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2d539905-4f79-49f4-92ad-558daad94441",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-38ff-73ec-82de-460f00843532.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel sink, black appliances, and granite countertops.",
        "public_id": "01a01601-38ff-73ec-82de-460f00843532",
        "storage_key": "property/6767906449165627/01a01601-38ff-73ec-82de-460f00843532.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this modern kitchen, featuring rich dark wood cabinets, sleek granite countertops, and a full suite of black appliances. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel sink, black appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f37b3777-befa-458a-b6e9-3a0501e77b62",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-356d-73ab-9355-8ab2d836d95f.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, TV, and armchair",
        "public_id": "01a01601-356d-73ab-9355-8ab2d836d95f",
        "storage_key": "property/6767906449165627/01a01601-356d-73ab-9355-8ab2d836d95f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace with a decorative mirror above, a TV on a modern cabinet, and a plush armchair for relaxation.",
      "link": "",
      "alt_text": "Living room with fireplace, TV, and armchair",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d38d1d8c-45a4-4b2a-988b-647e5be3e464",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-3a5a-771a-81a9-3f42d9eda468.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, granite countertops, black appliances, and white tile flooring.",
        "public_id": "01a01601-3a5a-771a-81a9-3f42d9eda468",
        "storage_key": "property/6767906449165627/01a01601-3a5a-771a-81a9-3f42d9eda468.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A spacious kitchen featuring dark wood cabinetry, sleek granite countertops, and modern black appliances, complemented by bright, neutral flooring.",
      "link": "",
      "alt_text": "Kitchen with dark wood cabinets, granite countertops, black appliances, and white tile flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_570c6dc6-de62-49bf-a3f5-490f3bdabd95",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-299e-7541-bc7d-ea7f4ec961e5.webp",
      "image_media": {
        "alt_text": "Living room with a green sofa, armchair, fireplace, and balcony access.",
        "public_id": "01a01601-299e-7541-bc7d-ea7f4ec961e5",
        "storage_key": "property/6767906449165627/01a01601-299e-7541-bc7d-ea7f4ec961e5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a stylish green sofa, a comfortable armchair, a cozy fireplace, and a sliding glass door leading to a private balcony.",
      "link": "",
      "alt_text": "Living room with a green sofa, armchair, fireplace, and balcony access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6d670d64-108f-45f7-b48c-2d7ff93fba30",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-237f-70ef-a7bd-0434e354529f.webp",
      "image_media": {
        "alt_text": "Screened-in balcony with a table and two chairs overlooking trees and apartment buildings.",
        "public_id": "01a01601-237f-70ef-a7bd-0434e354529f",
        "storage_key": "property/6767906449165627/01a01601-237f-70ef-a7bd-0434e354529f.webp",
        "width": 3072,
        "height": 2059
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening breeze on this charming screened-in balcony, offering a peaceful view of the surrounding community.",
      "link": "",
      "alt_text": "Screened-in balcony with a table and two chairs overlooking trees and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b3aae7c5-e418-4a19-af98-91f73f7177b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01600-f860-72d3-8d65-f0fa4be1c3f3.webp",
      "image_media": {
        "alt_text": "A well-lit bedroom with a queen-size bed, bedside table, and a large window.",
        "public_id": "01a01600-f860-72d3-8d65-f0fa4be1c3f3",
        "storage_key": "property/6767906449165627/01a01600-f860-72d3-8d65-f0fa4be1c3f3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this inviting bedroom, featuring a queen-size bed, elegant decor, and ample natural light from the large window.",
      "link": "",
      "alt_text": "A well-lit bedroom with a queen-size bed, bedside table, and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_faccd059-c3a7-4bc1-ba3c-fceab7ac923e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01600-ca16-71af-a6e8-1a0b2a456684.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, couch, coffee table, and console table.",
        "public_id": "01a01600-ca16-71af-a6e8-1a0b2a456684",
        "storage_key": "property/6767906449165627/01a01600-ca16-71af-a6e8-1a0b2a456684.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable seating, and decorative console table. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with fireplace, couch, coffee table, and console table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_303aa32c-c55c-415d-92d7-ccaa5634c8b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01600-abfa-7528-82d5-5354e45642bd.webp",
      "image_media": {
        "alt_text": "Balcony with two bar stools and a table, overlooking trees.",
        "public_id": "01a01600-abfa-7528-82d5-5354e45642bd",
        "storage_key": "property/6767906449165627/01a01600-abfa-7528-82d5-5354e45642bd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening drinks on your private balcony, complete with a seating area perfect for two.",
      "link": "",
      "alt_text": "Balcony with two bar stools and a table, overlooking trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2c5f60c4-ede2-48a9-9b63-e0c514a40279",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a015fe-d7bc-770e-acc8-c6f9c9bf9e24.webp",
      "image_media": {
        "alt_text": "A cozy bedroom featuring a large bed with a thick knit throw blanket, wooden nightstand, and minimalist artwork.",
        "public_id": "01a015fe-d7bc-770e-acc8-c6f9c9bf9e24",
        "storage_key": "property/6767906449165627/01a015fe-d7bc-770e-acc8-c6f9c9bf9e24.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover comfort and style in this beautifully appointed bedroom, complete with plush bedding and elegant decor.",
      "link": "",
      "alt_text": "A cozy bedroom featuring a large bed with a thick knit throw blanket, wooden nightstand, and minimalist artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a34e48be-63e1-47e9-a302-19390ddcee84",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a015fe-9207-74e4-b5cd-47d2528965ca.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, lamp, and decor.",
        "public_id": "01a015fe-9207-74e4-b5cd-47d2528965ca",
        "storage_key": "property/6767906449165627/01a015fe-9207-74e4-b5cd-47d2528965ca.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa adorned with decorative pillows, a modern coffee table, and ambient lighting from a floor lamp.",
      "link": "",
      "alt_text": "Living room with sofa, coffee table, lamp, and decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dd89a655-ebd5-4bc8-bf73-8f3dd42268d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a015fe-77d1-70f9-a186-df92bc48d3ed.webp",
      "image_media": {
        "alt_text": "Gym with weight machines, free weights, and cardio equipment.",
        "public_id": "01a015fe-77d1-70f9-a186-df92bc48d3ed",
        "storage_key": "property/6767906449165627/01a015fe-77d1-70f9-a186-df92bc48d3ed.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a full range of weight machines, free weights, and cardio equipment to help you stay active and healthy.",
      "link": "",
      "alt_text": "Gym with weight machines, free weights, and cardio equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e74a0a23-c7fe-42f2-a454-abf0a36ec906",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a015fe-8521-766f-b641-c0aaa8febf43.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, row machine, and free weights.",
        "public_id": "01a015fe-8521-766f-b641-c0aaa8febf43",
        "storage_key": "property/6767906449165627/01a015fe-8521-766f-b641-c0aaa8febf43.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines and a wide selection of free weights for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, row machine, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3bdebeb9-39a4-454f-b438-6e2f6c1aeb76",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a015fe-6358-7360-8eda-4614f6770b1d.webp",
      "image_media": {
        "alt_text": "Sugarberry Apartment Homes monument sign with landscaping.",
        "public_id": "01a015fe-6358-7360-8eda-4614f6770b1d",
        "storage_key": "property/6767906449165627/01a015fe-6358-7360-8eda-4614f6770b1d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Sugarberry Apartment Homes, where comfort and convenience meet in a vibrant community setting.",
      "link": "",
      "alt_text": "Sugarberry Apartment Homes monument sign with landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_64f706b5-5c00-40a0-87f9-5a2d7db43550",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a015fe-6a54-7458-92f6-c6faf3a46479.webp",
      "image_media": {
        "alt_text": "Spacious living room with a fireplace and green sectional sofa.",
        "public_id": "01a015fe-6a54-7458-92f6-c6faf3a46479",
        "storage_key": "property/6767906449165627/01a015fe-6a54-7458-92f6-c6faf3a46479.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community living room, featuring a cozy fireplace and comfortable seating.",
      "link": "",
      "alt_text": "Spacious living room with a fireplace and green sectional sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e4653ad0-f481-4e25-8e63-1964926f1a78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a015fe-62c1-72dc-98ce-e3fb030fc8e6.webp",
      "image_media": {
        "alt_text": "Spacious living room with green sectional sofas facing a fireplace and a large painting.",
        "public_id": "01a015fe-62c1-72dc-98ce-e3fb030fc8e6",
        "storage_key": "property/6767906449165627/01a015fe-62c1-72dc-98ce-e3fb030fc8e6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed community living room, featuring comfortable seating and a cozy fireplace.",
      "link": "",
      "alt_text": "Spacious living room with green sectional sofas facing a fireplace and a large painting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_792fcf81-3d94-4592-819c-a19061046d08",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a015fe-6c73-752e-b654-6a6c5add0c46.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, rowing machine, and ellipticals",
        "public_id": "01a015fe-6c73-752e-b654-6a6c5add0c46",
        "storage_key": "property/6767906449165627/01a015fe-6c73-752e-b654-6a6c5add0c46.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment like treadmills, rowing machines, and ellipticals for residents to enjoy.",
      "link": "",
      "alt_text": "Gym with treadmills, rowing machine, and ellipticals",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_60e373b0-0984-4fff-afd4-a25442869b12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a015fe-1e79-7748-b352-b83d4732a035.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with green and beige siding, and an outdoor staircase.",
        "public_id": "01a015fe-1e79-7748-b352-b83d4732a035",
        "storage_key": "property/6767906449165627/01a015fe-1e79-7748-b352-b83d4732a035.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings featuring green and beige siding, with an accessible ramp leading to an outdoor staircase. Surrounded by lush trees and landscaping.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with green and beige siding, and an outdoor staircase.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5b5aab84-dd85-45f5-bbb5-8c6eab9c8c5e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a015fd-bae2-736f-8fae-9d2f04d72ab8.webp",
      "image_media": {
        "alt_text": "Apartment community pool with lounge chairs and surrounding buildings and trees.",
        "public_id": "01a015fd-bae2-736f-8fae-9d2f04d72ab8",
        "storage_key": "property/6767906449165627/01a015fd-bae2-736f-8fae-9d2f04d72ab8.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by lush greenery and comfortable lounge chairs.",
      "link": "",
      "alt_text": "Apartment community pool with lounge chairs and surrounding buildings and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_44b368ca-c04d-468d-bc90-2ae60681d808",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a015fd-bb38-76bf-b534-4a3150a1ee35.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a grassy lawn and a fenced pool area.",
        "public_id": "01a015fd-bb38-76bf-b534-4a3150a1ee35",
        "storage_key": "property/6767906449165627/01a015fd-bb38-76bf-b534-4a3150a1ee35.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Showcasing the exteriors of the apartment buildings, surrounded by a lush green lawn and a pristine pool area, perfect for relaxation and outdoor enjoyment.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with a grassy lawn and a fenced pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b9739e41-ed34-40b2-9048-457b25190129",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb48-0f8b-74ce-9aca-b3606ee77d7a.webp",
      "image_media": {
        "alt_text": "Apartment complex swimming pool with lounge chairs and umbrellas",
        "public_id": "019cfb48-0f8b-74ce-9aca-b3606ee77d7a",
        "storage_key": "property/6767906449165627/019cfb48-0f8b-74ce-9aca-b3606ee77d7a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool, surrounded by lush trees and comfortable seating. Enjoy the resort-style amenities at our community.",
      "link": "",
      "alt_text": "Apartment complex swimming pool with lounge chairs and umbrellas",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fdb07b42-195a-4ba9-96b1-64fd71d55690",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb48-0cf5-73af-a2b7-9322a35ef2c1.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and trees.",
        "public_id": "019cfb48-0cf5-73af-a2b7-9322a35ef2c1",
        "storage_key": "property/6767906449165627/019cfb48-0cf5-73af-a2b7-9322a35ef2c1.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush trees and comfortable lounge chairs.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d3b9d7d0-1ac8-4f57-a0f5-ac4d85063bb1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb48-0cd3-74d9-b419-aa717318247b.webp",
      "image_media": {
        "alt_text": "Aerial view of an apartment complex swimming pool with lounge chairs and an umbrella.",
        "public_id": "019cfb48-0cd3-74d9-b419-aa717318247b",
        "storage_key": "property/6767906449165627/019cfb48-0cd3-74d9-b419-aa717318247b.webp",
        "width": 984,
        "height": 656
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling blue pool, surrounded by comfortable lounge chairs perfect for soaking up the sun.",
      "link": "",
      "alt_text": "Aerial view of an apartment complex swimming pool with lounge chairs and an umbrella.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a7215ec1-fc5b-4b21-b0e3-4daaf2fef8ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "11111 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain steakhouse known for its hand-cut steaks, ribs, and made-from-scratch sides.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and filet medallions, and their rolls with cinnamon butter are a highlight. They also highlight the affordable prices, fun atmosphere, and attentive service.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-6dd4-774e-85f4-96345d3f7710.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6dd4-774e-85f4-96345d3f7710",
        "storage_key": "property/6767906449165627/019d2709-6dd4-774e-85f4-96345d3f7710.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/tulsa-east-71st-st?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10669544637791228065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0613876",
      "poi_longitude": "-95.852648",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-461-8891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-9fc6-766a-a76e-203d231c5dd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9fc6-766a-a76e-203d231c5dd9",
        "storage_key": "property/6767906449165627/019d2709-9fc6-766a-a76e-203d231c5dd9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dEXckyMtocRoVC4glHWEZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_b2329db4-8b41-40a0-a05b-ed577ca7f3c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "8711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant offers a diverse menu with delicious pasta, burgers, and cheesecake. They also highlight the attentive and friendly service, and the warm and welcoming atmosphere, ideal for a casual yet elevated evening out.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-6d3c-7265-ad02-bb59a0e20386.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6d3c-7265-ad02-bb59a0e20386",
        "storage_key": "property/6767906449165627/019d2709-6d3c-7265-ad02-bb59a0e20386.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/tulsa-130.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=16222748060775136545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "36.0614349",
      "poi_longitude": "-95.8795591",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-249-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-9fc6-766a-a76e-203d231c5dd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9fc6-766a-a76e-203d231c5dd9",
        "storage_key": "property/6767906449165627/019d2709-9fc6-766a-a76e-203d231c5dd9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJhQ5aNtocRIb0o02jHIuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_bfea17d6-c106-4f74-b337-c10f4ce7c10b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "4810 S Yale Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Casual chain, known for battered chicken fingers, fries, Texas toast and signature sauce, as well as friendly service.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers and a tasty dipping sauce. They highlight the fair pricing and generous portions. They also like the fast and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-6da4-722f-b60c-7c05203e7d3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6da4-722f-b60c-7c05203e7d3a",
        "storage_key": "property/6767906449165627/019d2709-6da4-722f-b60c-7c05203e7d3a.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/tulsa/4810-s.-yale-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097855623742206873&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.0929086",
      "poi_longitude": "-95.9228346",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-477-9354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-9fc6-766a-a76e-203d231c5dd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9fc6-766a-a76e-203d231c5dd9",
        "storage_key": "property/6767906449165627/019d2709-9fc6-766a-a76e-203d231c5dd9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0uXiuqStocRmbPFyGHvn1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_c5d4ef43-3654-4a0e-a91d-edaf31070d84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4933 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Popular fast-food chain specializing in chicken sandwiches and nuggets.",
      "poi_long_description": "People say this fast food restaurant serves fresh food. They also highlight the friendly staff and fast service.\n\nOther reviews mention the drive-thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-6da9-708c-9cc2-8ce36b56ce73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6da9-708c-9cc2-8ce36b56ce73",
        "storage_key": "property/6767906449165627/019d2709-6da9-708c-9cc2-8ce36b56ce73.webp",
        "width": 1069,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/southroads-shopping-center?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13411138926925396352&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "36.1047058",
      "poi_longitude": "-95.919763",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-622-7815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-9fc6-766a-a76e-203d231c5dd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9fc6-766a-a76e-203d231c5dd9",
        "storage_key": "property/6767906449165627/019d2709-9fc6-766a-a76e-203d231c5dd9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6nzsMeStocRgDnNfMzvHbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_9f107abb-1231-4418-8473-f5ed8cb3380a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "10708 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly national chain serving classic American comfort foods, plus cocktails, beer and steaks.",
      "poi_long_description": "Diners say this traditional US American restaurant serves up delicious honey butter croissants, salmon, and steak. They also highlight the friendly and attentive service, reasonable prices, and generous portions.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-7212-772c-b6fc-471f4ee13a19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7212-772c-b6fc-471f4ee13a19",
        "storage_key": "property/6767906449165627/019d2709-7212-772c-b6fc-471f4ee13a19.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cheddars.com/locations/ok/tulsa/tulsa/2015?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:tulsa-ok-2015_pl:locurl_rd:1010",
      "poi_directions_map_url": "https://maps.google.com/?cid=11101010613821228024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "36.06025",
      "poi_longitude": "-95.85707",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-307-2013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-9fc6-766a-a76e-203d231c5dd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9fc6-766a-a76e-203d231c5dd9",
        "storage_key": "property/6767906449165627/019d2709-9fc6-766a-a76e-203d231c5dd9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM6XrprSNtocR-MOnbFa2Dpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_7999f9c0-80f0-4c07-938e-6a4b88f74afb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Woodland Hills Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Spacious, clean, 2-level shopping center featuring a carousel for kids as well as a variety of food options.",
      "poi_long_description": "Visitors say this shopping center has a wide variety of stores, including Scheels, Macy's, Dillard's, and JCPenney, and a great food court with many options. They also highlight the clean, safe, and friendly atmosphere, and the family-friendly environment with activities for children.\n\nSome reviews mention the escalators can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-7299-7608-8538-24b114c94104.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7299-7608-8538-24b114c94104",
        "storage_key": "property/6767906449165627/019d2709-7299-7608-8538-24b114c94104.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/woodland-hills-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6466318501171358790&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-hills-mall",
      "poi_latitude": "36.063341",
      "poi_longitude": "-95.881655",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-250-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a165-762f-ab8b-67db2b02dd28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a165-762f-ab8b-67db2b02dd28",
        "storage_key": "property/6767906449165627/019d2709-a165-762f-ab8b-67db2b02dd28.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRRuzasmr6vFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_24d49118-dd9a-4622-912a-8035c0cc8906",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7130 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Food mart stocking meat, baked goods and household staples, plus bulk bins.",
      "poi_long_description": "Shoppers say this grocery store offers great savings on a wide variety of items, including bulk goods like candy, nuts, and spices, as well as fresh produce and quality meats. They also highlight the store's 24/7 accessibility, reasonable prices, and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-72f4-717f-afab-f59c058a0569.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-72f4-717f-afab-f59c058a0569",
        "storage_key": "property/6767906449165627/019d2709-72f4-717f-afab-f59c058a0569.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8053298412458330468&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "36.0597141",
      "poi_longitude": "-95.8890336",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-888-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-9fae-71c4-9527-404d24c5cbd6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9fae-71c4-9527-404d24c5cbd6",
        "storage_key": "property/6767906449165627/019d2709-9fae-71c4-9527-404d24c5cbd6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62eScyGNtocRZMnL6DwQw28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a61a58bb-86e9-4316-9d46-10d85804fed4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Pan-Asia Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "10003 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Asian grocery store featuring fresh produce and seafood. Also on offer: sushi and tea.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of fresh produce, live seafood, and Asian groceries, including a large selection of meats, spices, and noodles. They highlight the fair prices, the clean and organized store, and the delicious hot food, boba tea, and sushi available at the cafe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-7291-766b-b572-aa2ec4576bbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7291-766b-b572-aa2ec4576bbe",
        "storage_key": "property/6767906449165627/019d2709-7291-766b-b572-aa2ec4576bbe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.panasiasupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1484729550679765321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pan-asia-supermarket",
      "poi_latitude": "36.0630212",
      "poi_longitude": "-95.8655271",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-940-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-9fae-71c4-9527-404d24c5cbd6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9fae-71c4-9527-404d24c5cbd6",
        "storage_key": "property/6767906449165627/019d2709-9fae-71c4-9527-404d24c5cbd6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1gpIX6NtocRSfHK76jRmhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_ee475de1-11c2-4a55-9082-3ff31db6e259",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "9136 S Yale Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "Market selling organic produce and gluten-free grocery items.",
      "poi_long_description": "People say this grocery store offers a wide selection of healthy and organic foods, including fresh produce, a salad bar, and a variety of vitamins and supplements. They also highlight the clean and organized layout, the friendly and helpful staff, and the relaxed shopping experience.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-76e7-75e5-be93-32239a116f6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-76e7-75e5-be93-32239a116f6b",
        "storage_key": "property/6767906449165627/019d2709-76e7-75e5-be93-32239a116f6b.webp",
        "width": 1280,
        "height": 603
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/yale?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690334156598386947&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "36.030638",
      "poi_longitude": "-95.9237179",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-879-0493",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-9fae-71c4-9527-404d24c5cbd6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9fae-71c4-9527-404d24c5cbd6",
        "storage_key": "property/6767906449165627/019d2709-9fae-71c4-9527-404d24c5cbd6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp2KYkCCStocRA6HtoRBqF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_3ebe31e8-413e-47c9-9e1b-3020fc6c3e0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "1525 S Yale Ave, Tulsa, OK 74112, USA",
      "poi_short_description": "Chain hardware store and home center stocked with lawn equipment, appliances, paint and patio furniture.",
      "poi_long_description": "People say this home improvement store offers a wide selection of appliances and DIY products. They also highlight the helpful staff and quick checkout.\n\nOther reviews mention the inventory can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-78b4-7622-b9a6-6f1f1eb9145a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-78b4-7622-b9a6-6f1f1eb9145a",
        "storage_key": "property/6767906449165627/019d2709-78b4-7622-b9a6-6f1f1eb9145a.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Tulsa/1580?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1580-_-na-_-0-_-0&y_source=1_MTE4NDQwNC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12278391127478819263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "36.1396197",
      "poi_longitude": "-95.9196011",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-712-8199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a165-762f-ab8b-67db2b02dd28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a165-762f-ab8b-67db2b02dd28",
        "storage_key": "property/6767906449165627/019d2709-a165-762f-ab8b-67db2b02dd28.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJcRFpChXttocRv9muPq2bZao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_496286d8-645f-4af3-a88b-ff31df2f436e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Oral Roberts University",
      "poi_type": "Education",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74171, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-7776-717c-b657-7793cdcb1d7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7776-717c-b657-7793cdcb1d7c",
        "storage_key": "property/6767906449165627/019d2709-7776-717c-b657-7793cdcb1d7c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173931362498967750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oral-roberts-university",
      "poi_latitude": "36.0508093",
      "poi_longitude": "-95.9528284",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-495-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-9fff-74d1-b965-0aae80aed949.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9fff-74d1-b965-0aae80aed949",
        "storage_key": "property/6767906449165627/019d2709-9fff-74d1-b965-0aae80aed949.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwdeD7iTtocRxvgglcY007Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9c9701b1-3b09-451f-aa37-a4f9a0e86b6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Tulsa Community College Southeast Campus",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-77fc-702b-ba29-ab1ff0daed49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-77fc-702b-ba29-ab1ff0daed49",
        "storage_key": "property/6767906449165627/019d2709-77fc-702b-ba29-ab1ff0daed49.webp",
        "width": 1280,
        "height": 924
      },
      "poi_business_url": "https://www.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8389070837534418764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-community-college-southeast-campus",
      "poi_latitude": "36.0448034",
      "poi_longitude": "-95.8624934",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-595-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-9fff-74d1-b965-0aae80aed949.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9fff-74d1-b965-0aae80aed949",
        "storage_key": "property/6767906449165627/019d2709-9fff-74d1-b965-0aae80aed949.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1olEM6NtocRTOfTwnr3a3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_848968cc-1203-4e1a-87ec-7a16392cbf60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Hardesty Regional Library",
      "poi_type": "Education",
      "poi_address": "8316 E 93rd St, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed library featuring kids' sections (some with play areas and puzzles) plus meeting rooms and study space.",
      "poi_long_description": "People say this public library offers a wide selection of books, study rooms, and computers. They highlight the clean and safe environment, and the helpful staff. They also like the separate kids and adult sections, and the dedicated teen space. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-7b30-703c-8d66-904cbdca85d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7b30-703c-8d66-904cbdca85d5",
        "storage_key": "property/6767906449165627/019d2709-7b30-703c-8d66-904cbdca85d5.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "http://www.tulsalibrary.org/hardesty",
      "poi_directions_map_url": "https://maps.google.com/?cid=3083775875462030879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hardesty-regional-library",
      "poi_latitude": "36.0268456",
      "poi_longitude": "-95.8830539",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-9fff-74d1-b965-0aae80aed949.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9fff-74d1-b965-0aae80aed949",
        "storage_key": "property/6767906449165627/019d2709-9fff-74d1-b965-0aae80aed949.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKe3yqg6OtocRH2bV99HFyyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_5d3f3283-b67b-4685-8b1b-b5532b5d9c09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "OU-Tulsa",
      "poi_type": "Education",
      "poi_address": "4502 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-7cb0-737e-904c-765067f6a158.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7cb0-737e-904c-765067f6a158",
        "storage_key": "property/6767906449165627/019d2709-7cb0-737e-904c-765067f6a158.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tulsa.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=247462858016865972&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ou-tulsa",
      "poi_latitude": "36.1024131",
      "poi_longitude": "-95.9259796",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-660-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-9fff-74d1-b965-0aae80aed949.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9fff-74d1-b965-0aae80aed949",
        "storage_key": "property/6767906449165627/019d2709-9fff-74d1-b965-0aae80aed949.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcz8INcGStocRtL4ygygqbwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f8d3117b-a33d-49e7-b579-6e087f193d3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Martin Regional Library",
      "poi_type": "Education",
      "poi_address": "2601 S Garnett Rd, Tulsa, OK 74129, USA",
      "poi_short_description": "Public library with a range of services, including faxing, computers, and meetings, plus Vietnamese books.",
      "poi_long_description": "People say this public library offers a wide selection of books, comfortable seating, and convenient printing services. They highlight the quiet atmosphere, helpful staff, and friendly librarians. They also like the charging stations and the monthly vegan potluck. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-7c8f-770d-9e8f-0475540c506f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7c8f-770d-9e8f-0475540c506f",
        "storage_key": "property/6767906449165627/019d2709-7c8f-770d-9e8f-0475540c506f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tulsalibrary.org/martin/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6046822168243383481&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martin-regional-library",
      "poi_latitude": "36.1265968",
      "poi_longitude": "-95.8505489",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-9fff-74d1-b965-0aae80aed949.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9fff-74d1-b965-0aae80aed949",
        "storage_key": "property/6767906449165627/019d2709-9fff-74d1-b965-0aae80aed949.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF1eFsi7ztocRuawafrmg6lM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_b72f8076-f576-4286-8a9f-f6e497a95c34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "3328 E 51st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Family-friendly chain featuring trampolines, climbing walls, ropes courses and other active recreational options.",
      "poi_long_description": "People say this amusement park offers a variety of activities, including trampolines, go-karts, zip lines, and virtual reality. They also highlight the helpful staff and the fun atmosphere for birthday parties.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-7d80-7469-a07b-214c3bb95972.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7d80-7469-a07b-214c3bb95972",
        "storage_key": "property/6767906449165627/019d2709-7d80-7469-a07b-214c3bb95972.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/oklahoma-tulsa/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3062250087465279410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "36.0884996",
      "poi_longitude": "-95.9384116",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-770-9987",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a359-76fc-9e13-f636ec243834",
        "storage_key": "property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wX9dvyTtocRst_G5DpMfyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_7eddfe67-9db4-4531-98ae-d0772b9f1206",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Mabee Center",
      "poi_type": "Entertainment",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "Sprawling facility for concerts, basketball events and graduations, plus other events.",
      "poi_long_description": "Entertainment venue hosting nationally known performers, church services, sports & family events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-7fd7-76c2-830d-281ebfe26993.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7fd7-76c2-830d-281ebfe26993",
        "storage_key": "property/6767906449165627/019d2709-7fd7-76c2-830d-281ebfe26993.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://mabeecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7042245147778354535&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mabee-center",
      "poi_latitude": "36.0480386",
      "poi_longitude": "-95.9557686",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-495-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a359-76fc-9e13-f636ec243834",
        "storage_key": "property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuUFxgMeTtocRZw2MhqYUu2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_ea4f9f2f-2bef-4354-9fc2-6a258bb8ba26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "8306 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Gravity-defying entertainment venue with state-of-the-art trampolines, plus dodgeball courts.",
      "poi_long_description": "People say this amusement park offers fun trampolines, attractions, and a zip line. They also highlight the massage chairs for adults and the designated space for birthday parties.\n\nOther reviews mention the customer service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-81ad-735c-8b3a-aea5ad8bf542.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-81ad-735c-8b3a-aea5ad8bf542",
        "storage_key": "property/6767906449165627/019d2709-81ad-735c-8b3a-aea5ad8bf542.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "https://www.skyzone.com/tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2967499010622421820&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "36.07405900000001",
      "poi_longitude": "-95.883873",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-877-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a359-76fc-9e13-f636ec243834",
        "storage_key": "property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3PGwZ2NtocRPPt4r6CsLik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_a319438e-4614-4f74-b67f-0b7df6bde663",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Golden Driller Statue",
      "poi_type": "Entertainment",
      "poi_address": "Tulsa Expo Center, 4145 E 21st St, Tulsa, OK 74114, USA",
      "poi_short_description": "Golden, roadside landmark, built in 1953 in Tulsa, of an oil worker (nicknamed “the Driller”), 75 feet tall, adorned with a T-shirt, representing a time when the town was known as the “oil capital of the world”.",
      "poi_long_description": "Visitors say this historical landmark is a must-see, especially for those from out of town, and they praise the statue's impressive size. They also highlight that parking is free and it's a great place to stop for photos, especially during events like the Tulsa State Fair.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-82a5-712e-8e92-4d4cb3dcab7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-82a5-712e-8e92-4d4cb3dcab7c",
        "storage_key": "property/6767906449165627/019d2709-82a5-712e-8e92-4d4cb3dcab7c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://exposquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14322764790652212651&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-driller-statue",
      "poi_latitude": "36.1337734",
      "poi_longitude": "-95.9311081",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-596-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a359-76fc-9e13-f636ec243834",
        "storage_key": "property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJswh6RCPttocRqxVMHLGuxMY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_2eaaa2ac-63c4-470a-abfa-b4913bec0271",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Slick City Action Park",
      "poi_type": "Entertainment",
      "poi_address": "5352 E Skelly Dr, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a variety of fun slides, a basketball court, and a play area for younger children. They also highlight the friendly and helpful staff, and the clean and safe environment.\n\nOther reviews mention the concessions can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-8282-73ba-a913-db82c56a0182.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8282-73ba-a913-db82c56a0182",
        "storage_key": "property/6767906449165627/019d2709-8282-73ba-a913-db82c56a0182.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://slickcity.com/ok-tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=12324602171454774354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slick-city-action-park",
      "poi_latitude": "36.0979811",
      "poi_longitude": "-95.9157069",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-818-7423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a359-76fc-9e13-f636ec243834",
        "storage_key": "property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFytTvJWTtocRUtyRW2DICas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_bca2f22e-e099-4237-97c3-1af617335fc2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "10642 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Athletic country club featuring indoor and outdoor pools, yoga classes, and basketball and pickleball courts, plus a cafe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-8478-7565-a6b3-fbd64cd6d83d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8478-7565-a6b3-fbd64cd6d83d",
        "storage_key": "property/6767906449165627/019d2709-8478-7565-a6b3-fbd64cd6d83d.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/south-tulsa.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=3628922520137756888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "36.0093414",
      "poi_longitude": "-95.8899718",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-364-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a359-76fc-9e13-f636ec243834",
        "storage_key": "property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwVCKhaOtocR2PA5Is6FXDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d9f25913-1fcd-445c-8583-0f9ff5190469",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Crunch Fitness - Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "7827 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Friendly gym, fitness-oriented chain, featuring cardio equipment, group classes, and personal-training services.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and group classes, and has a clean facility with helpful and knowledgeable staff.\n\nOther reviews mention the membership cancellation process can be difficult and the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-8719-77c9-92dd-b941b0d11aeb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8719-77c9-92dd-b941b0d11aeb",
        "storage_key": "property/6767906449165627/019d2709-8719-77c9-92dd-b941b0d11aeb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=3614973288206348263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---tulsa",
      "poi_latitude": "36.0337164",
      "poi_longitude": "-95.8883964",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 539-842-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a359-76fc-9e13-f636ec243834",
        "storage_key": "property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB747NHCNtocR568QfA33KjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d80ee46f-acf9-4ffb-938a-213095529ecf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Crunch Fitness - Broken Arrow",
      "poi_type": "Health and Wellness",
      "poi_address": "3701 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Gym offering fitness classes, cardio equipment, and personal training, plus tanning.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and machines. They also highlight the friendly and helpful staff, and the clean and spacious facility.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-86f4-71bd-b8fa-5e16afa48745.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-86f4-71bd-b8fa-5e16afa48745",
        "storage_key": "property/6767906449165627/019d2709-86f4-71bd-b8fa-5e16afa48745.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/brokenarrow",
      "poi_directions_map_url": "https://maps.google.com/?cid=7237271301754615382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---broken-arrow",
      "poi_latitude": "36.0152872",
      "poi_longitude": "-95.7956716",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-395-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a359-76fc-9e13-f636ec243834",
        "storage_key": "property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wtAG4WJtocRVnY2fOfzb2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a2e5b885-81ab-4fd8-abb4-ad2217a0c2c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1808 N Elm Pl, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain gym offering a variety of workout equipment, including tanning beds, in a clean environment.",
      "poi_long_description": "People say this gym offers a wide selection of equipment and is clean and well-maintained. They highlight the affordable membership and convenient location. They also like the friendly and supportive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-87d3-70ea-9aab-ec724e946832.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-87d3-70ea-9aab-ec724e946832",
        "storage_key": "property/6767906449165627/019d2709-87d3-70ea-9aab-ec724e946832.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/broken-arrow-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=8211862053813118143&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0700775",
      "poi_longitude": "-95.7999697",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-739-6224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a359-76fc-9e13-f636ec243834",
        "storage_key": "property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNfEd95mLtocRv2QKlgdl9nE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5a1e9e72-3600-48ac-86fd-11e693db6fb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "iidentity salon",
      "poi_type": "Health and Wellness",
      "poi_address": "2731 S Harvard Ave, Tulsa, OK 74114, USA",
      "poi_short_description": "Hair styling salon with a friendly staff and a warm atmosphere, offering cuts and coloring services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-8902-762b-8a49-f30559a22231.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8902-762b-8a49-f30559a22231",
        "storage_key": "property/6767906449165627/019d2709-8902-762b-8a49-f30559a22231.webp",
        "width": 960,
        "height": 893
      },
      "poi_business_url": "http://www.iidentitysalon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9820300745508314431&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "iidentity-salon",
      "poi_latitude": "36.1232992",
      "poi_longitude": "-95.9400579",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-747-2566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a359-76fc-9e13-f636ec243834",
        "storage_key": "property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ8vHnFGTtocRP92Gc3-3SIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_f05d7c43-d2f3-4258-aeb3-87cc53fa8a21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "9142 E 31st St, Tulsa, OK 74145, USA",
      "poi_short_description": "Gym offering cardio and strength-training equipment, as well as Pilates, yoga, and cycling classes.",
      "poi_long_description": "People say this gym offers a wide variety of new equipment, including free weights, machines, and cardio options, as well as classes and tanning booths. They highlight the clean facilities, spacious layout, and 24/7 availability, making it convenient for people with unpredictable schedules. They also like the friendly, helpful, and understanding staff, and the welcoming, non-judgmental atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-8bca-735d-9a54-e4ee106f61c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8bca-735d-9a54-e4ee106f61c8",
        "storage_key": "property/6767906449165627/019d2709-8bca-735d-9a54-e4ee106f61c8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://10gym.com/east-tulsa-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16362762748097342813&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.1175059",
      "poi_longitude": "-95.8708861",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-438-0193",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a359-76fc-9e13-f636ec243834",
        "storage_key": "property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh4own9SMtocRXS1WmAY2FOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c2425f50-5513-48d0-8902-692437c090ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "4915 E 41st St Suite A, Tulsa, OK 74135, USA",
      "poi_short_description": "Beauty retailer carrying a wide selection of products and offering salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-8bc9-760d-a80f-0904b0c569ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8bc9-760d-a80f-0904b0c569ae",
        "storage_key": "property/6767906449165627/019d2709-8bc9-760d-a80f-0904b0c569ae.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/tulsa-ok-131",
      "poi_directions_map_url": "https://maps.google.com/?cid=10581466912609131404&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "36.1058946",
      "poi_longitude": "-95.9208289",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-664-5916",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a359-76fc-9e13-f636ec243834",
        "storage_key": "property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWeUzsceStocRjNudEBjs2JI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_4d70dc10-3802-4866-9d5b-967bb659e69c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Saint Francis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6161 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-8d8a-74ad-9f02-ba1a07e68f68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8d8a-74ad-9f02-ba1a07e68f68",
        "storage_key": "property/6767906449165627/019d2709-8d8a-74ad-9f02-ba1a07e68f68.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=60921030837772717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital",
      "poi_latitude": "36.0717124",
      "poi_longitude": "-95.919824",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-494-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a414-71ad-a2cf-4083e3ecb080.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a414-71ad-a2cf-4083e3ecb080",
        "storage_key": "property/6767906449165627/019d2709-a414-71ad-a2cf-4083e3ecb080.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbj84V-StocRraFv0lpv2AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_db099e06-9ce3-4e5a-8a65-5696fe6290ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Hillcrest South",
      "poi_type": "Health and Wellness",
      "poi_address": "8801 S 101st E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-8dda-70b8-bbe4-4970e393ee6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8dda-70b8-bbe4-4970e393ee6f",
        "storage_key": "property/6767906449165627/019d2709-8dda-70b8-bbe4-4970e393ee6f.webp",
        "width": 1280,
        "height": 890
      },
      "poi_business_url": "https://hillcrest.com/find-a-provider/location/hillcrestsouth8801s101steave/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4505690926352009573&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hillcrest-south",
      "poi_latitude": "36.0354556",
      "poi_longitude": "-95.8635828",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-294-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a414-71ad-a2cf-4083e3ecb080.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a414-71ad-a2cf-4083e3ecb080",
        "storage_key": "property/6767906449165627/019d2709-a414-71ad-a2cf-4083e3ecb080.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJx-fcY9aNtocRZYnpfAZuhz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_237254e5-b3a6-475d-a9cc-584154b06224",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Rhema Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a beautiful display of Christmas lights, with a light show synchronized to music. They highlight the festive and family-friendly atmosphere, and the opportunity to walk or drive through the light experience. They also like the availability of hot cocoa, popcorn, and horse-drawn carriage rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-90ee-7793-90fb-f020cda44ffe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-90ee-7793-90fb-f020cda44ffe",
        "storage_key": "property/6767906449165627/019d2709-90ee-7793-90fb-f020cda44ffe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rhemalights.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7029601498986534882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rhema-park",
      "poi_latitude": "36.0599323",
      "poi_longitude": "-95.808211",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-258-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a399-77ec-8c3c-4ec8be731bbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a399-77ec-8c3c-4ec8be731bbb",
        "storage_key": "property/6767906449165627/019d2709-a399-77ec-8c3c-4ec8be731bbb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQLUiIyLtocR4lelo1EpjmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_44b71c79-51d0-4225-a493-3b1605dbce7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "LaFortune Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5202 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Vast park, with playground areas, golf options, tennis courts, a pool and a community center.",
      "poi_long_description": "People say this park offers a golf course, playgrounds, walking trails, and picnic areas with grills. They highlight the park is clean, well-maintained, and safe, with plenty of parking and covered pavilions. They also like the wide walkways and the peaceful, quiet atmosphere. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-90b4-7255-9eaa-38dea6744146.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-90b4-7255-9eaa-38dea6744146",
        "storage_key": "property/6767906449165627/019d2709-90b4-7255-9eaa-38dea6744146.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www2.tulsacounty.org/parks/parks-facilities/lafortune-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16150311355247615027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lafortune-park",
      "poi_latitude": "36.0830954",
      "poi_longitude": "-95.9178327",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-496-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a399-77ec-8c3c-4ec8be731bbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a399-77ec-8c3c-4ec8be731bbb",
        "storage_key": "property/6767906449165627/019d2709-a399-77ec-8c3c-4ec8be731bbb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh59BfPOStocRM9x9DZxuIeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d18f907d-5598-4761-ab9b-13fe1bf905c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Elam Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74011, USA",
      "poi_short_description": "Fenced park featuring picnic tables and a playground for children.",
      "poi_long_description": "People say this park offers a variety of playground equipment, including slides, swings, and a zipline, as well as picnic tables, soccer fields, and a water fountain with a bottle refill station. They highlight the park's clean bathrooms, shaded seating areas, and fenced-in playground, making it safe and enjoyable for children of all ages. They also like the park's accessible layout and thoughtful design, especially for toddlers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-9307-74b6-a444-6b862d897400.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9307-74b6-a444-6b862d897400",
        "storage_key": "property/6767906449165627/019d2709-9307-74b6-a444-6b862d897400.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.brokenarrowok.gov/Home/Components/News/News/2234/15",
      "poi_directions_map_url": "https://maps.google.com/?cid=8281012522592314667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elam-park",
      "poi_latitude": "36.0062955",
      "poi_longitude": "-95.8209464",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a399-77ec-8c3c-4ec8be731bbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a399-77ec-8c3c-4ec8be731bbb",
        "storage_key": "property/6767906449165627/019d2709-a399-77ec-8c3c-4ec8be731bbb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW_XMAgCPtocRKyWtvQMR7HI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_28d62f4b-910d-44e0-8da4-796a00b0f049",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Hunter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5804 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "Well-maintained park featuring a playground for kids and a dog park for pets, plus a splash pad and a pond for fishing.",
      "poi_long_description": "People say this park offers a disc golf course, a dog park with separate areas for large and small dogs, and a pond with fishing piers. They highlight the peaceful and safe environment, and the extensive dog park with play features and picnic spots. They also like the wooded trails and the availability of water fountains for dogs. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-9343-748d-84eb-6554f74da710.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9343-748d-84eb-6554f74da710",
        "storage_key": "property/6767906449165627/019d2709-9343-748d-84eb-6554f74da710.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoftulsa.org/culture--recreation/tulsa-parks.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13505697753323470752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hunter-park",
      "poi_latitude": "36.0298785",
      "poi_longitude": "-95.9117817",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-596-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a399-77ec-8c3c-4ec8be731bbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a399-77ec-8c3c-4ec8be731bbb",
        "storage_key": "property/6767906449165627/019d2709-a399-77ec-8c3c-4ec8be731bbb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzzqpPeRtocRoP-i5ozgbbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bdecf896-bfc5-4d9d-af54-67c2ac1de2b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Haikey Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11327 S Garnett Rd, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Calm park featuring frisbee golf, disc golf, swings and a playground for kids.",
      "poi_long_description": "People say this park offers a disc golf course, multiple playgrounds, walking trails, and picnic areas. They highlight the park is large, well-maintained, and has plenty of shaded areas. They also like the clean pavilions, volleyball, horseshoes, and open spaces for various activities. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-963b-71aa-9b52-3101b02c7346.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-963b-71aa-9b52-3101b02c7346",
        "storage_key": "property/6767906449165627/019d2709-963b-71aa-9b52-3101b02c7346.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15453125230281067031&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haikey-creek-park",
      "poi_latitude": "35.9918271",
      "poi_longitude": "-95.8526659",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-369-5998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a399-77ec-8c3c-4ec8be731bbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a399-77ec-8c3c-4ec8be731bbb",
        "storage_key": "property/6767906449165627/019d2709-a399-77ec-8c3c-4ec8be731bbb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkz_xefyOtocRF4qH1IWHdNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d456290f-f97a-4617-b834-f55c69b9441f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Harvey Young Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1419 S 135th E Ave, Tulsa, OK 74108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-9700-70f6-8d6e-b7e04b477a00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9700-70f6-8d6e-b7e04b477a00",
        "storage_key": "property/6767906449165627/019d2709-9700-70f6-8d6e-b7e04b477a00.webp",
        "width": 1242,
        "height": 932
      },
      "poi_business_url": "http://harvey-young-airport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11091711320843246332&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harvey-young-airport",
      "poi_latitude": "36.1412138",
      "poi_longitude": "-95.8256711",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-298-4044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a53d-7618-9c8a-3a5c373de9f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a53d-7618-9c8a-3a5c373de9f8",
        "storage_key": "property/6767906449165627/019d2709-a53d-7618-9c8a-3a5c373de9f8.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJffM4REPztocR_FoKDq6s7Zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_59a7bb67-682d-4049-a4bf-c1c56a9959a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Cityplex Towers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2488 E 81st St, Tulsa, OK 74137, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-98f8-746b-be06-add9b37b58aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-98f8-746b-be06-add9b37b58aa",
        "storage_key": "property/6767906449165627/019d2709-98f8-746b-be06-add9b37b58aa.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cityplextowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12250163942111608689&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cityplex-towers",
      "poi_latitude": "36.0427518",
      "poi_longitude": "-95.9528286",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-493-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a359-76fc-9e13-f636ec243834",
        "storage_key": "property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTNcyMaTtocRcX_cgTNTAao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_33ef6a73-601b-482b-b8af-784268cfa406",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Hilti - Operations Center Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5400 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-97fb-7538-90bf-d79a31f74103.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-97fb-7538-90bf-d79a31f74103",
        "storage_key": "property/6767906449165627/019d2709-97fb-7538-90bf-d79a31f74103.webp",
        "width": 760,
        "height": 512
      },
      "poi_business_url": "http://hilti.to/ubo2wq",
      "poi_directions_map_url": "https://maps.google.com/?cid=4109057745683559288&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hilti---operations-center-corporate-office",
      "poi_latitude": "36.0872879",
      "poi_longitude": "-95.8430938",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-252-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a359-76fc-9e13-f636ec243834",
        "storage_key": "property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUE4gPGMtocReDMJvT9OBjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_50a41d98-721e-45cb-a2b9-8b1e4b340d8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Enovation Controls",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5311 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-9bbc-763f-82fc-11b249a6983d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9bbc-763f-82fc-11b249a6983d",
        "storage_key": "property/6767906449165627/019d2709-9bbc-763f-82fc-11b249a6983d.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.enovationcontrols.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1461315099535642429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "enovation-controls",
      "poi_latitude": "36.0861778",
      "poi_longitude": "-95.8391635",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-317-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a359-76fc-9e13-f636ec243834",
        "storage_key": "property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_tas_OMtocRPY-8NFeiRxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f2ed5906-4ea4-4f3c-8fe9-594a37e21f79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Mill Creek General Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6974 E 38th St, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.millcreeklumber.com/distribution_general_offices_tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17106239654103162435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mill-creek-general-offices",
      "poi_latitude": "36.1071459",
      "poi_longitude": "-95.8972379",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-794-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a359-76fc-9e13-f636ec243834",
        "storage_key": "property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYu7OliNtocRQx6FKVWSZe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c5286210-e7c9-4414-a293-471957f4a0e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Air Hygiene International, Inc. - Stack and Emissions Testing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 W Tacoma St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-9bc0-77c4-8b2b-124dc04465b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9bc0-77c4-8b2b-124dc04465b1",
        "storage_key": "property/6767906449165627/019d2709-9bc0-77c4-8b2b-124dc04465b1.webp",
        "width": 1280,
        "height": 613
      },
      "poi_business_url": "https://www.airhygiene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17853602463665443212&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "air-hygiene-international-inc---stack-and-emissions-testing",
      "poi_latitude": "36.0713795",
      "poi_longitude": "-95.8092029",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-307-8865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a359-76fc-9e13-f636ec243834",
        "storage_key": "property/6767906449165627/019d2709-a359-76fc-9e13-f636ec243834.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Ut31oWLtocRjFHRJ9m8xPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c7b7241f-889a-4eff-a842-83bfe24ab267",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Oklahoma State University Center for Health Sciences",
      "poi_type": "Education",
      "poi_address": "717 S Houston Ave # 200, Tulsa, OK 74127, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://medicine.okstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14426676051692162656&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-state-university-center-for-health-sciences",
      "poi_latitude": "36.1471963",
      "poi_longitude": "-95.9975585",
      "poi_miles_from_property": "12.2 mi",
      "poi_walking_minutes": "4 hours 32 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-586-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c962-721a-a9fd-07ffb9e2d86e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c962-721a-a9fd-07ffb9e2d86e",
        "storage_key": "property/6767906449165627/019cfb47-c962-721a-a9fd-07ffb9e2d86e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW_QYv3HrtocRYA6_5m7ZNcg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a1cb7c5f-5067-4df3-bbc8-8f3097a64862",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Darnaby Elementary School",
      "poi_type": "Education",
      "poi_address": "7625 E 87th St, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://darnaby.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17731132405919378329&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "darnaby-elementary-school",
      "poi_latitude": "36.0395128",
      "poi_longitude": "-95.8915411",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-357-4333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c962-721a-a9fd-07ffb9e2d86e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c962-721a-a9fd-07ffb9e2d86e",
        "storage_key": "property/6767906449165627/019cfb47-c962-721a-a9fd-07ffb9e2d86e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4-KztvuNtocRmes9yPqiEfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ac7a34a9-e35b-4448-b41f-cbc2b337b136",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Union Eighth Grade Center",
      "poi_type": "Education",
      "poi_address": "6501 S Garnett Rd, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019dbbe7-825f-7124-955e-1bf763923331.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe7-825f-7124-955e-1bf763923331",
        "storage_key": "property/6767906449165627/019dbbe7-825f-7124-955e-1bf763923331.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "http://unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8773159022692442711&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-eighth-grade-center",
      "poi_latitude": "36.0671931",
      "poi_longitude": "-95.8503859",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-357-4325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c962-721a-a9fd-07ffb9e2d86e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c962-721a-a9fd-07ffb9e2d86e",
        "storage_key": "property/6767906449165627/019cfb47-c962-721a-a9fd-07ffb9e2d86e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJwUczVGMtocRV6KYIaaFwHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_c211fc9f-bcdd-4de0-a06c-af1cf242c16d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Union High School S.T.E.M. Building",
      "poi_type": "Education",
      "poi_address": "Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2228436292019187956&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-high-school-s-t-e-m-building",
      "poi_latitude": "36.07223889999999",
      "poi_longitude": "-95.8668365",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c962-721a-a9fd-07ffb9e2d86e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c962-721a-a9fd-07ffb9e2d86e",
        "storage_key": "property/6767906449165627/019cfb47-c962-721a-a9fd-07ffb9e2d86e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEUoJZ12NtocR9HBkNgD_7B4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_083e9275-29ef-463e-8329-736ff19fb153",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Tulsa Welding School",
      "poi_type": "Education",
      "poi_address": "2545 E 11th St, Tulsa, OK 74104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-16e4-73ad-b864-e4acb95fc87f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-16e4-73ad-b864-e4acb95fc87f",
        "storage_key": "property/6767906449165627/019d7913-16e4-73ad-b864-e4acb95fc87f.webp",
        "width": 720,
        "height": 540
      },
      "poi_business_url": "https://www.tws.edu/campus/tulsa/?vid=stratatech&utm_source=google+plus&utm_medium=organic&utm_campaign=gmb-tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=14857828250111281257&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-welding-school",
      "poi_latitude": "36.1479802",
      "poi_longitude": "-95.9540828",
      "poi_miles_from_property": "10.5 mi",
      "poi_walking_minutes": "3 hours 54 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-216-0723",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c962-721a-a9fd-07ffb9e2d86e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c962-721a-a9fd-07ffb9e2d86e",
        "storage_key": "property/6767906449165627/019cfb47-c962-721a-a9fd-07ffb9e2d86e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYxp2Ke7stocRaYilxRKcMc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_524bb8b0-982d-4a5a-84ff-23b30b0b6a40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Cedar Ridge Elementary School",
      "poi_type": "Education",
      "poi_address": "9817 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019dbbe7-8664-7572-b86c-2585d1950446.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe7-8664-7572-b86c-2585d1950446",
        "storage_key": "property/6767906449165627/019dbbe7-8664-7572-b86c-2585d1950446.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cedarridge.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7739981988625288061&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cedar-ridge-elementary-school",
      "poi_latitude": "36.0219642",
      "poi_longitude": "-95.8673969",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-357-4331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c962-721a-a9fd-07ffb9e2d86e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c962-721a-a9fd-07ffb9e2d86e",
        "storage_key": "property/6767906449165627/019cfb47-c962-721a-a9fd-07ffb9e2d86e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq3IV_G-OtocRfYvuR5zwaWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_dd33e1cf-234f-467b-b679-8625bd91d979",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Union 6th/7th Grade Center",
      "poi_type": "Education",
      "poi_address": "10100 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-2e9f-768f-9e02-705c00381dab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2e9f-768f-9e02-705c00381dab",
        "storage_key": "property/6767906449165627/019d7913-2e9f-768f-9e02-705c00381dab.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "http://www.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12357368135835625738&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-6th-7th-grade-center",
      "poi_latitude": "36.0750199",
      "poi_longitude": "-95.8647424",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-357-4326",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c962-721a-a9fd-07ffb9e2d86e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c962-721a-a9fd-07ffb9e2d86e",
        "storage_key": "property/6767906449165627/019cfb47-c962-721a-a9fd-07ffb9e2d86e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG0q97M9mtocRCqk279gwfqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_633c348d-6505-4edc-a1ac-01785755750d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Memorial High School",
      "poi_type": "Education",
      "poi_address": "5840 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-315f-719d-8d5e-4f237bac268c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-315f-719d-8d5e-4f237bac268c",
        "storage_key": "property/6767906449165627/019d7913-315f-719d-8d5e-4f237bac268c.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://memorial.tulsaschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13857617040675689831&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "memorial-high-school",
      "poi_latitude": "36.0789084",
      "poi_longitude": "-95.9145622",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-833-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c962-721a-a9fd-07ffb9e2d86e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c962-721a-a9fd-07ffb9e2d86e",
        "storage_key": "property/6767906449165627/019cfb47-c962-721a-a9fd-07ffb9e2d86e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY_WXTomStocRZ9XfFkclUMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_512b502a-2936-406d-b8f0-20d41520dc87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Rhema Bible Training College",
      "poi_type": "Education",
      "poi_address": "1025 W Kenosha St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-2ea0-701e-b42f-7b5846c8ea3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2ea0-701e-b42f-7b5846c8ea3f",
        "storage_key": "property/6767906449165627/019d7913-2ea0-701e-b42f-7b5846c8ea3f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.rbtc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11947881279901651820&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rhema-bible-training-college",
      "poi_latitude": "36.0590515",
      "poi_longitude": "-95.8055648",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-258-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c962-721a-a9fd-07ffb9e2d86e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c962-721a-a9fd-07ffb9e2d86e",
        "storage_key": "property/6767906449165627/019cfb47-c962-721a-a9fd-07ffb9e2d86e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcwlpHh6LtocRbNMTs7hmz6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_62a152cf-f8ca-4bef-90c8-75c6e33c0d90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Sake2Me Sushi",
      "poi_type": "Restaurants",
      "poi_address": "9205 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Casual Japanese restaurant offering all-you-can-eat sushi & sashimi, plus noodles & teriyaki dishes.",
      "poi_long_description": "People say this sushi restaurant offers delicious and fresh sushi, including a wide variety of rolls and sashimi, as well as teriyaki chicken and calamari. They highlight the generous portions, reasonable prices, and the all-you-can-eat option, which they find to be a great value. They also like the chill and relaxed atmosphere, and the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-34ed-7309-96f2-d48daa447aec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-34ed-7309-96f2-d48daa447aec",
        "storage_key": "property/6767906449165627/019d7913-34ed-7309-96f2-d48daa447aec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sake2mesushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9793506518580779662&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sake2me-sushi",
      "poi_latitude": "36.061592",
      "poi_longitude": "-95.873192",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-249-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c955-74fa-b5dc-c4cb1677e70d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c955-74fa-b5dc-c4cb1677e70d",
        "storage_key": "property/6767906449165627/019cfb47-c955-74fa-b5dc-c4cb1677e70d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSeCG1folTIYRjtp6WUqG6Yc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_7bd00f13-10c0-48be-8a8b-8870896937f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Texas de Brazil - Tulsa",
      "poi_type": "Restaurants",
      "poi_address": "7021 S Memorial Dr Ste 176, Tulsa, OK 74133, USA",
      "poi_short_description": "Upscale Brazilian eatery featuring all-you-can-eat grilled meat carved tableside & a salad bar.",
      "poi_long_description": "Upscale Brazilian eatery featuring all-you-can-eat grilled meat carved tableside & a salad bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-3712-75aa-8dc0-56b658694671.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3712-75aa-8dc0-56b658694671",
        "storage_key": "property/6767906449165627/019d7913-3712-75aa-8dc0-56b658694671.webp",
        "width": 1280,
        "height": 865
      },
      "poi_business_url": "https://texasdebrazil.com/locations/tulsa/?utm_source=gmb&utm_medium=yext&y_source=1_NDg4MzA3MTYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=18226415542484854114&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "texas-de-brazil-tulsa",
      "poi_latitude": "36.0627542",
      "poi_longitude": "-95.8803523",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-921-7994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c955-74fa-b5dc-c4cb1677e70d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c955-74fa-b5dc-c4cb1677e70d",
        "storage_key": "property/6767906449165627/019cfb47-c955-74fa-b5dc-c4cb1677e70d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjQkYPpeNtocRYuV3Ql488fw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_c6832aaa-2a34-4045-8762-a2baf4809cff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Tulsa’s Incredible Food and Fun",
      "poi_type": "Restaurants",
      "poi_address": "8314 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Popular place for parties offering go-karts, rides, games & pizza with an all-you-can-eat buffet.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of food, including pizza, hot dogs, tacos, and a salad bar, and has fun games and attractions like laser tag, bumper cars, and a roller coaster. They also highlight the fun, family-friendly atmosphere and the helpful, friendly staff.\n\nOther reviews mention some games can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-3a21-7412-a260-8b7428b72141.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3a21-7412-a260-8b7428b72141",
        "storage_key": "property/6767906449165627/019d7913-3a21-7412-a260-8b7428b72141.webp",
        "width": 502,
        "height": 270
      },
      "poi_business_url": "https://incrediblefoodandfun.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16906715592224650215&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-s-incredible-food-and-fun",
      "poi_latitude": "36.0589793",
      "poi_longitude": "-95.8832543",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-294-8671",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c955-74fa-b5dc-c4cb1677e70d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c955-74fa-b5dc-c4cb1677e70d",
        "storage_key": "property/6767906449165627/019cfb47-c955-74fa-b5dc-c4cb1677e70d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJidT2-ZONtocR57MbaUG4oOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_a71dca7a-b63a-4e15-9c68-b494087d7012",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Bricktown Brewery",
      "poi_type": "Restaurants",
      "poi_address": "9409 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Casual pizza joint specializing in local brews and serving burgers and seafood platters.",
      "poi_long_description": "Diners say this restaurant serves up delicious chicken fried chicken, chicken fried steak, and breakfast burgers, and they praise the Kolsch beer. They also highlight the friendly and attentive service, and the welcoming atmosphere.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-43a1-7711-87b7-3d4ab7f066ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-43a1-7711-87b7-3d4ab7f066ea",
        "storage_key": "property/6767906449165627/019d7913-43a1-7711-87b7-3d4ab7f066ea.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://bricktownbrewery.com/location/woodland-hills/?utm_source=gbp&utm_medium=cpc&utm_campaign=bricktown_brewery",
      "poi_directions_map_url": "https://maps.google.com/?cid=4102797412021264681&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bricktown-brewery",
      "poi_latitude": "36.0614101",
      "poi_longitude": "-95.8716959",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-994-4456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c955-74fa-b5dc-c4cb1677e70d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c955-74fa-b5dc-c4cb1677e70d",
        "storage_key": "property/6767906449165627/019cfb47-c955-74fa-b5dc-c4cb1677e70d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0bN2wL2NtocRKWHrOIIQ8Dg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3621b53e-7c4b-4223-99cb-3d19e99f134a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Uncle Julio's Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "10333 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Tex-Mex chain serving mesquite-grilled fare & margarita-sangria swirls in a hacienda-style space.",
      "poi_long_description": "People say this Mexican restaurant serves delicious fajitas, homemade tortillas, and margaritas. They also highlight the attentive service and fun, festive atmosphere.\n\nOther reviews mention the portions can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-4d39-72e5-b88d-128fbf66ae34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4d39-72e5-b88d-128fbf66ae34",
        "storage_key": "property/6767906449165627/019d7913-4d39-72e5-b88d-128fbf66ae34.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://unclejulios.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8326019147073341189&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "uncle-julio-s-mexican-restaurant",
      "poi_latitude": "36.0622881",
      "poi_longitude": "-95.8608222",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-999-0054",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c955-74fa-b5dc-c4cb1677e70d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c955-74fa-b5dc-c4cb1677e70d",
        "storage_key": "property/6767906449165627/019cfb47-c955-74fa-b5dc-c4cb1677e70d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7TjRyvSNtocRBUdoFk32i3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_665c4e7c-559d-4852-9fca-059c3b3e47b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Carrabba's Italian Grill",
      "poi_type": "Restaurants",
      "poi_address": "11021 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain eatery & bar serving a diverse menu of classic Italian fare in a family-friendly setting.",
      "poi_long_description": "Diners say this Italian restaurant serves up delicious spaghetti and mussels, with many praising the generous portions. They also highlight the attentive and friendly service, as well as the warm and inviting atmosphere.\n\nSome reviews mention the prices can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-47f3-70f4-8df8-dab61a19f3c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-47f3-70f4-8df8-dab61a19f3c9",
        "storage_key": "property/6767906449165627/019d7913-47f3-70f4-8df8-dab61a19f3c9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.carrabbas.com/oklahoma/tulsa/11021-east-71st-street?y_source=1_MTU1MDI5NTYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2567335840563463566&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "carrabba-s-italian-grill",
      "poi_latitude": "36.0613832",
      "poi_longitude": "-95.8537575",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-254-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c955-74fa-b5dc-c4cb1677e70d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c955-74fa-b5dc-c4cb1677e70d",
        "storage_key": "property/6767906449165627/019cfb47-c955-74fa-b5dc-c4cb1677e70d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCSNJfUyMtocRjgXqO1gCoSM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_39a3355d-d012-47ba-984f-7501832796e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Chuy's",
      "poi_type": "Restaurants",
      "poi_address": "10808 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain serving \"big as yo' face\" burritos & other Tex-Mex dishes in kitschy, eclectic settings.",
      "poi_long_description": "People say this Tex-Mex restaurant serves delicious fajitas, chile rellenos, and shrimp tacos. They also highlight the reasonable prices, fun and relaxed vibe, and friendly service.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-44bd-7399-b9d6-4bc13764ff7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-44bd-7399-b9d6-4bc13764ff7c",
        "storage_key": "property/6767906449165627/019d7913-44bd-7399-b9d6-4bc13764ff7c.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.chuys.com/locations/ok/tulsa/tulsa-ok/6031?cmpid=br:chy_ag:ie_ch:loc_ca:CHYGMB_sn:gmb_gt:tulsa-ok-6031_pl:locurl_rd:1030",
      "poi_directions_map_url": "https://maps.google.com/?cid=15724210836110639618&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chuy-s",
      "poi_latitude": "36.0603153",
      "poi_longitude": "-95.8561867",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-252-0405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c955-74fa-b5dc-c4cb1677e70d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c955-74fa-b5dc-c4cb1677e70d",
        "storage_key": "property/6767906449165627/019cfb47-c955-74fa-b5dc-c4cb1677e70d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8TEdVbONtocRAgK563GeN9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "custom_3c21426e-06c2-476c-9b7b-842717fdfc72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "9808 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store has helpful and friendly staff who are knowledgeable about their areas. They also highlight the well-stocked store and efficient delivery service.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-4d05-768c-aa6b-d242479596a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4d05-768c-aa6b-d242479596a0",
        "storage_key": "property/6767906449165627/019d7913-4d05-768c-aa6b-d242479596a0.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/South-Tulsa/OK/Tulsa/74133/3903?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1237148003252488434&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "36.0595045",
      "poi_longitude": "-95.8665226",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-459-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c961-71dc-99e1-fecd22258f11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c961-71dc-99e1-fecd22258f11",
        "storage_key": "property/6767906449165627/019cfb47-c961-71dc-99e1-fecd22258f11.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvaH1r7CNtocR8shy5I07KxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_1cf87399-8629-4962-a8e7-dc9369f3f220",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Barnes & Noble",
      "poi_type": "Shopping & Retail",
      "poi_address": "Woodland Plaza, 8620 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Bookseller chain stocking housebrand eReader, plus a broad selection of titles for adults & kids.",
      "poi_long_description": "People say this bookstore offers a wide selection of books, including manga, and a variety of novelty items, educational toys, puzzles, and crafts. They highlight the spacious layout, the reading area, and the cafe. They also like the helpful and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-538e-70fa-93b0-32088fa56ecb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-538e-70fa-93b0-32088fa56ecb",
        "storage_key": "property/6767906449165627/019d7913-538e-70fa-93b0-32088fa56ecb.webp",
        "width": 1280,
        "height": 724
      },
      "poi_business_url": "https://stores.barnesandnoble.com/store/2585",
      "poi_directions_map_url": "https://maps.google.com/?cid=15890114772298800904&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "barnes-noble",
      "poi_latitude": "36.0601131",
      "poi_longitude": "-95.8799161",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-250-5034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c961-71dc-99e1-fecd22258f11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c961-71dc-99e1-fecd22258f11",
        "storage_key": "property/6767906449165627/019cfb47-c961-71dc-99e1-fecd22258f11.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJcYxgZ5aNtocRCJ8OKzIHhdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_fc3e5cfe-3f23-4c48-86c9-57c2db0c9da3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Macy's",
      "poi_type": "Shopping & Retail",
      "poi_address": "8707 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Department store chain providing brand-name clothing, accessories, home furnishings & housewares.",
      "poi_long_description": "Department store chain providing brand-name clothing, accessories, home furnishings & housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-5877-7249-b646-dfe71404f6bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5877-7249-b646-dfe71404f6bb",
        "storage_key": "property/6767906449165627/019d7913-5877-7249-b646-dfe71404f6bb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.macys.com/stores/ok/tulsa/woodland-hills-mall_680.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=6065174495787256153&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "macy-s",
      "poi_latitude": "36.0629828",
      "poi_longitude": "-95.8793463",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-250-2990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c961-71dc-99e1-fecd22258f11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c961-71dc-99e1-fecd22258f11",
        "storage_key": "property/6767906449165627/019cfb47-c961-71dc-99e1-fecd22258f11.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvW88N5aNtocRWYkouhHUK1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_4f8a5b83-2439-4671-991b-30e025ff32c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Reasor's",
      "poi_type": "Shopping & Retail",
      "poi_address": "11005 E 41st St, Tulsa, OK 74146, USA",
      "poi_short_description": "Regional grocery chain featuring a bakery, deli and floral department.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, deli items, and baked goods, including strawberry cakes. They also highlight the friendly and helpful staff, and the clean environment.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-5bea-77e7-8b79-a406a1e30f9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5bea-77e7-8b79-a406a1e30f9f",
        "storage_key": "property/6767906449165627/019d7913-5bea-77e7-8b79-a406a1e30f9f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.reasors.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4661132903532256902&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "reasor-s",
      "poi_latitude": "36.10579269999999",
      "poi_longitude": "-95.8544435",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-610-0610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c955-74fa-b5dc-bd2004977120.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c955-74fa-b5dc-bd2004977120",
        "storage_key": "property/6767906449165627/019cfb47-c955-74fa-b5dc-bd2004977120.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgUHd59iMtocRht7sFa6rr0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_94e3cf69-3901-462f-aebf-038d63905a8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "10111 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, meats, and bulk foods, including organic and natural options. They also highlight the friendly and helpful staff, and the clean, well-organized shopping environment.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-5dbb-7002-80f8-84b81dfb0a83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5dbb-7002-80f8-84b81dfb0a83",
        "storage_key": "property/6767906449165627/019d7913-5dbb-7002-80f8-84b81dfb0a83.webp",
        "width": 1280,
        "height": 1007
      },
      "poi_business_url": "https://sprouts.com/store/ok/tulsa/bixby",
      "poi_directions_map_url": "https://maps.google.com/?cid=4212849996008007892&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "36.01613340000001",
      "poi_longitude": "-95.8850383",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-364-7272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c955-74fa-b5dc-bd2004977120.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c955-74fa-b5dc-bd2004977120",
        "storage_key": "property/6767906449165627/019cfb47-c955-74fa-b5dc-bd2004977120.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO2njyBCOtocR1CgQMMAMdzo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_3fa6a4d0-649f-4862-9a25-bd7fd7cb6e2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Utica Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "1709 Utica Square, Tulsa, OK 74114, USA",
      "poi_short_description": "Tree-lined outdoor shopping center open since 1952, featuring upscale chain brands & casual dining.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including popular retail brands, specialty shops, and a Saks Fifth Avenue, as well as numerous dining options. They highlight the beautiful, open-air layout, the convenient parking, and the relaxed and inviting atmosphere. They also like the well-maintained landscaping and seasonal decorations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-6969-750c-895b-5d3764ae0c97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6969-750c-895b-5d3764ae0c97",
        "storage_key": "property/6767906449165627/019d7913-6969-750c-895b-5d3764ae0c97.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.uticasquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1952460493464208074&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "utica-square",
      "poi_latitude": "36.1321689",
      "poi_longitude": "-95.9628953",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-588-5209",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c961-71dc-99e1-fecd22258f11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c961-71dc-99e1-fecd22258f11",
        "storage_key": "property/6767906449165627/019cfb47-c961-71dc-99e1-fecd22258f11.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAVNNJr_stocRygLrZnmIGBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_693e0bae-91f5-4155-8cb0-b243208c0071",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Riverwalk Crossing",
      "poi_type": "Shopping & Retail",
      "poi_address": "300 Riverwalk Terrace, Jenks, OK 74037, USA",
      "poi_short_description": "Lifestyle center on the Arkansas River and Muscogee (Creek) Nation reservation, with shopping, dining, live music, and a trail system.",
      "poi_long_description": "People say this shopping center offers a great selection of food and snacks, with many mentioning the Mexican grill. They also highlight the fun and peaceful atmosphere, beautiful scenery, and great service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-716c-766e-a00f-1f5e7cd7ca76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-716c-766e-a00f-1f5e7cd7ca76",
        "storage_key": "property/6767906449165627/019d7913-716c-766e-a00f-1f5e7cd7ca76.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.jenksriverwalk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11784666382402635584&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "riverwalk-crossing",
      "poi_latitude": "36.0256838",
      "poi_longitude": "-95.95905820000002",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-518-6675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c961-71dc-99e1-fecd22258f11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c961-71dc-99e1-fecd22258f11",
        "storage_key": "property/6767906449165627/019cfb47-c961-71dc-99e1-fecd22258f11.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJu9Z8JGCRtocRQMeYD6OLi6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f1e0ce76-7f7e-495d-9aa0-4d75956a2c5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Floor & Decor",
      "poi_type": "Shopping & Retail",
      "poi_address": "10303 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain with a variety of flooring ranging from tile to marble, plus backsplashes, sinks & more.",
      "poi_long_description": "People say this flooring store offers a wide variety of tiles. They highlight the reasonable prices and helpful staff. They also like the good customer service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-6ee9-75f3-8bf8-96bec86516e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6ee9-75f3-8bf8-96bec86516e4",
        "storage_key": "property/6767906449165627/019d7913-6ee9-75f3-8bf8-96bec86516e4.webp",
        "width": 1244,
        "height": 699
      },
      "poi_business_url": "https://www.flooranddecor.com/store/tulsa/OK/74133/253?utm_source=gmb&utm_medium=organic&utm_campaign=dsg_tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=992681097683368478&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "floor-decor",
      "poi_latitude": "36.06413879999999",
      "poi_longitude": "-95.861377",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-505-6546",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c961-71dc-99e1-fecd22258f11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c961-71dc-99e1-fecd22258f11",
        "storage_key": "property/6767906449165627/019cfb47-c961-71dc-99e1-fecd22258f11.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJh9iKjVmNtocRHnqp6jK2xg0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "building_materials_store"
    },
    {
      "id": "custom_6d5de012-1618-448c-bb63-b5c4c4a9b2ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Mathis Home",
      "poi_type": "Shopping & Retail",
      "poi_address": "6611 S 101st E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain selling furniture for every room in the home at budget-friendly prices.",
      "poi_long_description": "People say this furniture store offers a wide selection of mattresses, recliners, and other home furnishings. They highlight the helpful, knowledgeable, and professional staff, and the free delivery service. They also like the friendly and not pushy sales approach.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-746b-7119-86d8-1c5d1d4fecb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-746b-7119-86d8-1c5d1d4fecb6",
        "storage_key": "property/6767906449165627/019d7913-746b-7119-86d8-1c5d1d4fecb6.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.mathishome.com/stores/tulsa-52.html?utm_source=google&utm_medium=gbp&utm_campaign=website-button&utm_term=mbf-52&utm_content=website-button",
      "poi_directions_map_url": "https://maps.google.com/?cid=18144859354603892312&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mathis-home",
      "poi_latitude": "36.0677034",
      "poi_longitude": "-95.861197",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-461-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c961-71dc-99e1-fecd22258f11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c961-71dc-99e1-fecd22258f11",
        "storage_key": "property/6767906449165627/019cfb47-c961-71dc-99e1-fecd22258f11.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTURj6q2NtocRWK6WinJ9z_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_83803d2b-bb7a-4510-b0ca-4911226dc419",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Gilcrease Museum",
      "poi_type": "Entertainment",
      "poi_address": "1400 N Gilcrease Museum Rd, Tulsa, OK 74127, USA",
      "poi_short_description": "Museum housing extensive collections of art & artifacts of the American West & Native Americans.",
      "poi_long_description": "People say this art museum offers thoughtfully curated exhibits that provide deep insight into American history, Native American art, and the history of the West. They highlight the beautiful and peaceful grounds, and the well-organized and engaging experience. They also like the knowledgeable and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-788f-705b-9d06-521e3cab568d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-788f-705b-9d06-521e3cab568d",
        "storage_key": "property/6767906449165627/019d7913-788f-705b-9d06-521e3cab568d.webp",
        "width": 1280,
        "height": 736
      },
      "poi_business_url": "http://gilcrease.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13539514656066097772&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gilcrease-museum",
      "poi_latitude": "36.1742658",
      "poi_longitude": "-96.0210402",
      "poi_miles_from_property": "14.9 mi",
      "poi_walking_minutes": "5 hours 34 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 918-596-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-b057-77c7-aa7d-25f4f46b5ab9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-b057-77c7-aa7d-25f4f46b5ab9",
        "storage_key": "property/6767906449165627/019d7913-b057-77c7-aa7d-25f4f46b5ab9.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgf7O0rXrtocRbNIDItgE5rs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_58a2c0c6-5581-4b81-828f-cae172f28d58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Philbrook Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "2727 S Rockford Rd, Tulsa, OK 74114, USA",
      "poi_short_description": "Global collection of fine & decorative art in an ornate Italian Renaissance-style mansion & gardens.",
      "poi_long_description": "People say this museum offers a diverse collection of art, including traditional and modern pieces, and a beautiful Samurai exhibit. They highlight the stunning architecture, the well-maintained gardens and grounds, and the serene views. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-7fe8-77d8-8912-9ecfe43562ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7fe8-77d8-8912-9ecfe43562ec",
        "storage_key": "property/6767906449165627/019d7913-7fe8-77d8-8912-9ecfe43562ec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.philbrook.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1301074669923315730&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "philbrook-museum-of-art",
      "poi_latitude": "36.1238549",
      "poi_longitude": "-95.9700944",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-749-7941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-b057-77c7-aa7d-25f4f46b5ab9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-b057-77c7-aa7d-25f4f46b5ab9",
        "storage_key": "property/6767906449165627/019d7913-b057-77c7-aa7d-25f4f46b5ab9.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0VsvX7DstocRErAJ14RYDhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a23dc1a4-4796-4708-9b48-3ca0a3bf956c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Tulsa Zoo",
      "poi_type": "Entertainment",
      "poi_address": "6421 E 36th St N, Tulsa, OK 74115, USA",
      "poi_short_description": "An expansive, educational park with a huge variety of animals, plus the Safari Train & a carousel.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including elephants, sea lions, and tigers, and has a dinosaur exhibit, carousel, and playground. They highlight the membership is worth it, especially for large groups, and the zoo is family-friendly. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-81c7-73af-a7f0-f003fa6c5bb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-81c7-73af-a7f0-f003fa6c5bb6",
        "storage_key": "property/6767906449165627/019d7913-81c7-73af-a7f0-f003fa6c5bb6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tulsazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10038979359347895889&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-zoo",
      "poi_latitude": "36.2130153",
      "poi_longitude": "-95.9064904",
      "poi_miles_from_property": "12.6 mi",
      "poi_walking_minutes": "4 hours 39 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-669-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c962-721a-a9fd-0abe399a1781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c962-721a-a9fd-0abe399a1781",
        "storage_key": "property/6767906449165627/019cfb47-c962-721a-a9fd-0abe399a1781.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjb_PwwXutocRUe5o3YmeUYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_11f20e6d-146f-401a-a786-1474467fbf6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "The Cave House",
      "poi_type": "Entertainment",
      "poi_address": "1623 Charles Page Blvd, Tulsa, OK 74127, USA",
      "poi_short_description": "false",
      "poi_long_description": "Visitors say this tourist attraction offers a unique and fascinating experience with its whimsical, cave-like exterior and quirky, eclectic interior. They also highlight the knowledgeable and passionate management who provides captivating tours, sharing stories about the house's history and rumored connections to prohibition-era tunnels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-8a52-740f-b522-28adaf4aaa75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8a52-740f-b522-28adaf4aaa75",
        "storage_key": "property/6767906449165627/019d7913-8a52-740f-b522-28adaf4aaa75.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://cavehousetulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2036454794667285882&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-cave-house",
      "poi_latitude": "36.1517261",
      "poi_longitude": "-96.0112601",
      "poi_miles_from_property": "13.0 mi",
      "poi_walking_minutes": "4 hours 47 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-378-1952",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c962-721a-a9fd-0abe399a1781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c962-721a-a9fd-0abe399a1781",
        "storage_key": "property/6767906449165627/019cfb47-c962-721a-a9fd-0abe399a1781.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT5fkfgzrtocRet1IndjwQhw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_db056172-0dab-401c-b715-99d19b0b5b69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "BOK Center",
      "poi_type": "Entertainment",
      "poi_address": "200 S Denver Ave., Tulsa, OK 74103, USA",
      "poi_short_description": "High-design, eco-conscious arena hosting professional sports plus concerts & festivals.",
      "poi_long_description": "Visitors say this arena hosts exciting hockey games and concerts, and they appreciate the friendly and helpful staff. They also highlight the clean facilities and easy access to parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-8d5f-7059-8271-96e8863bddb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8d5f-7059-8271-96e8863bddb0",
        "storage_key": "property/6767906449165627/019d7913-8d5f-7059-8271-96e8863bddb0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bokcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13467435354223455802&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bok-center",
      "poi_latitude": "36.1527314",
      "poi_longitude": "-95.996545",
      "poi_miles_from_property": "12.6 mi",
      "poi_walking_minutes": "4 hours 42 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-894-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c962-721a-a9fd-0abe399a1781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c962-721a-a9fd-0abe399a1781",
        "storage_key": "property/6767906449165627/019cfb47-c962-721a-a9fd-0abe399a1781.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ966yH3frtocROq4G5Bnx5bo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_d0a7a851-67ab-463e-8dc4-34f741d12d83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Woody Guthrie Center",
      "poi_type": "Entertainment",
      "poi_address": "102 E Reconciliation Wy, Tulsa, OK 74103, USA",
      "poi_short_description": "Archives & exhibits related to the famed folk singer plus Dust Bowl-era & regional history displays.",
      "poi_long_description": "People say this museum offers a diverse collection of exhibits, including a popular Hip Hop exhibit, and a punk, rap, and rock n roll exhibit. They highlight the informative and engaging experience, and the well-done presentation of the exhibits. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-934b-72ce-82d3-8d6c5376ef7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-934b-72ce-82d3-8d6c5376ef7a",
        "storage_key": "property/6767906449165627/019d7913-934b-72ce-82d3-8d6c5376ef7a.webp",
        "width": 674,
        "height": 957
      },
      "poi_business_url": "http://woodyguthriecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6859463959324375305&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "woody-guthrie-center",
      "poi_latitude": "36.1586125",
      "poi_longitude": "-95.9922848",
      "poi_miles_from_property": "12.6 mi",
      "poi_walking_minutes": "4 hours 42 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-574-2710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-b057-77c7-aa7d-25f4f46b5ab9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-b057-77c7-aa7d-25f4f46b5ab9",
        "storage_key": "property/6767906449165627/019d7913-b057-77c7-aa7d-25f4f46b5ab9.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Y436YLrtocRCbkfxSC2MV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_62ce2322-5c4b-46c1-923e-d4c105b80afe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Center of the Universe",
      "poi_type": "Entertainment",
      "poi_address": "1 S Boston Ave, Tulsa, OK 74103, USA",
      "poi_short_description": "Mysterious spot where visitors stand on a circle & noises they make are echoed back much louder.",
      "poi_long_description": "People say this tourist attraction offers a unique acoustic phenomenon where visitors can hear their own voice echo. They also highlight the experience is fun, interesting, and worth a quick stop.\n\nOther reviews mention the site can be under construction.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-9a6a-77fc-99ad-9496e3789c7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9a6a-77fc-99ad-9496e3789c7b",
        "storage_key": "property/6767906449165627/019d7913-9a6a-77fc-99ad-9496e3789c7b.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11744256338230757911&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "center-of-the-universe",
      "poi_latitude": "36.1568986",
      "poi_longitude": "-95.9915366",
      "poi_miles_from_property": "12.5 mi",
      "poi_walking_minutes": "4 hours 39 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c962-721a-a9fd-0abe399a1781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c962-721a-a9fd-0abe399a1781",
        "storage_key": "property/6767906449165627/019cfb47-c962-721a-a9fd-0abe399a1781.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ3sdgoLrtocRF8pfd-r6-6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_ba359559-7453-4109-977b-6e1a77ce0f0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Tulsa Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "110 E 2nd St S, Tulsa, OK 74103, USA",
      "poi_short_description": "6 venues presenting dance, theater, music & other programs by local & visiting artists.",
      "poi_long_description": "People say this performing arts theater offers a variety of shows, including Broadway productions, local theater, ballet, and concerts. They highlight the excellent acoustics, comfortable seating, and good sightlines from most seats. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-9bbf-709f-822f-299373e13b25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9bbf-709f-822f-299373e13b25",
        "storage_key": "property/6767906449165627/019d7913-9bbf-709f-822f-299373e13b25.webp",
        "width": 821,
        "height": 313
      },
      "poi_business_url": "http://www.tulsapac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1663529134971770182&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-performing-arts-center",
      "poi_latitude": "36.154635",
      "poi_longitude": "-95.989282",
      "poi_miles_from_property": "12.2 mi",
      "poi_walking_minutes": "4 hours 33 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-596-7111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c962-721a-a9fd-0abe399a1781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c962-721a-a9fd-0abe399a1781",
        "storage_key": "property/6767906449165627/019cfb47-c962-721a-a9fd-0abe399a1781.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmblR2HjrtocRRlWBO-8KFhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_ae8df79e-2ba9-4c76-9eb1-7824924b9342",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "River Parks",
      "poi_type": "Entertainment",
      "poi_address": "Riverside Dr, Tulsa, OK 74105, USA",
      "poi_short_description": "Park with a splash pad for kids, plus trails for biking and walking.",
      "poi_long_description": "People say this park offers beautiful walking and biking trails. They highlight the scenic views, vibrant energy, and calm atmosphere. They also like the well-maintained trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-a45f-75ac-b13b-fbb315c02018.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a45f-75ac-b13b-fbb315c02018",
        "storage_key": "property/6767906449165627/019d7913-a45f-75ac-b13b-fbb315c02018.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://riverparks.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13339295593307788983&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "river-parks",
      "poi_latitude": "36.0822916",
      "poi_longitude": "-95.9845085",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-596-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c955-74fa-b5dc-c05baad85186.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c955-74fa-b5dc-c05baad85186",
        "storage_key": "property/6767906449165627/019cfb47-c955-74fa-b5dc-c05baad85186.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqXxsR52UtocRt1YL4aqyHrk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0d6478da-e78a-4be0-9606-ffaae152b011",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "poi_name": "Tulsa Garden Center at Woodward Park",
      "poi_type": "Entertainment",
      "poi_address": "2435 S Peoria Ave, Tulsa, OK 74114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019d7913-a6d3-77bb-8362-b80c3ff6ed1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a6d3-77bb-8362-b80c3ff6ed1d",
        "storage_key": "property/6767906449165627/019d7913-a6d3-77bb-8362-b80c3ff6ed1d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.tulsagardencenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10124481265987083554&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-garden-center-at-woodward-park",
      "poi_latitude": "36.1294877",
      "poi_longitude": "-95.9740818",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 41 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-576-5155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-c962-721a-a9fd-0abe399a1781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-c962-721a-a9fd-0abe399a1781",
        "storage_key": "property/6767906449165627/019cfb47-c962-721a-a9fd-0abe399a1781.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjxEsgaPstocRIt1B0hFigYw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    }
  ],
  "office_hours": [
    {
      "id": "ec_da5d868c105bb05674d8a65b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_7baa70c3e832d46dc4b3b994",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a6630d6d69348e3149b89723",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_086d7270225ebb02394e3b6e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_63dd422fd1584f95883baece",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_fbdb32db12cdeca7592655ab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_410ff9e5-25d7-4f4f-a2e8-3eb9144bbc22",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "rating": "5.0",
      "name": "Robert Rotherham",
      "text": "Sugarberry Apartments, Such A Clean & Nice Environment..The Move In Process Is Very Welcoming & Smooth. All Employees Are Very Nice . & The Maintenance Crew Is On Top Of It All . Did A Nice Job With Some Fixtures & Is Overall A Great Place To Be.",
      "date": "2025-06-21",
      "title": ""
    },
    {
      "id": "custom_733c41c5-3fbb-40ca-a8d1-49d62b0d987e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "rating": "5.0",
      "name": "A R",
      "text": "Sugarberry has been an excellent choice for us.\nManagement is  very personable and  engaged with the residents.\nThe maintenance crew is quick, efficient and extremely friendly.\nThe grounds are well maintained and looked after. I'm finishing my 6th year here, and am very pleased with my choice.",
      "date": "2025-07-12",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_11edae53-a7ba-43d5-8d6f-c6ccf1f05488",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb48-6228-738e-8995-945b1a190181.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360-degree view of a swimming pool and building exterior.",
        "public_id": "019cfb48-6228-738e-8995-945b1a190181",
        "storage_key": "property/6767906449165627/019cfb48-6228-738e-8995-945b1a190181.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Sugarberry Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=62ff6a28d0ef131bb62447aa"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-6a42-7473-8df7-20836467023d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "sugarberry-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627"
    },
    {
      "lead_collector_id": "019cf79e-6ab1-75d9-bb46-80021dbc656c",
      "lead_source": "LANDING_PAGE",
      "name": "sugarberry-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-south-tulsa",
      "search_query": "pet friendly apartments south tulsa",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments South Tulsa",
      "h2_subtitle": "Looking for pet friendly apartments in South Tulsa? Discover Sugarberry Apartments, where pets are welcome and amenities abound.",
      "page_copy": "Welcome to Sugarberry Apartments, the perfect destination for pet-friendly living in South Tulsa. Our community embraces a warm, inviting atmosphere where your furry friends are always welcome. Enjoy spacious one, two, and three-bedroom floor plans equipped with modern conveniences designed to meet your needs.\n\nOur pet play area ensures that your pets have enough space to frolic and socialize. Besides being a haven for pets, Sugarberry Apartments offers residents access to features like a business center, a refreshing pool, and a well-equipped fitness center. Choose Sugarberry Apartments and experience the finest in pet-friendly living in South Tulsa today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-aaf6-7079-8f59-92213a43e042.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a fireplace, comfortable sofa, and glass coffee table.",
        "public_id": "019cfb47-aaf6-7079-8f59-92213a43e042",
        "storage_key": "property/6767906449165627/019cfb47-aaf6-7079-8f59-92213a43e042.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in South Tulsa",
      "seo_description": "Discover pet friendly apartments in South Tulsa at Sugarberry Apartments, offering great amenities and a welcoming atmosphere for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "generator",
      "page_item_url": "apartments-with-pools-tulsa-ok",
      "search_query": "apartments with pools in tulsa ok",
      "category": "Amenity",
      "h1_title": "Apartments with Pools in Tulsa, OK",
      "h2_subtitle": "Searching for apartments with pools in Tulsa, OK? Dive into comfort at Sugarberry Apartments with our stunning pool area and other top-notch amenities.",
      "page_copy": "At Sugarberry Apartments in Tulsa, OK, we offer the perfect blend of relaxation and convenience, featuring our luxurious pool as one of the prominent highlights. Imagine unwinding after a long day with a refreshing dip in our pool, where relaxation is just a splash away.\n\nApart from our inviting pool, our community boasts a host of modern amenities, including a fitness center, pet play area, and various floor plans to suit your lifestyle. Located in the vibrant South Tulsa neighborhood, Sugarberry Apartments is the ideal choice for those seeking well-rounded living with a poolside retreat. Experience superior leisure and convenience at our community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-aaf6-7079-8f59-92213a43e042.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a fireplace, comfortable sofa, and glass coffee table.",
        "public_id": "019cfb47-aaf6-7079-8f59-92213a43e042",
        "storage_key": "property/6767906449165627/019cfb47-aaf6-7079-8f59-92213a43e042.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxurious Apartments with Pools in Tulsa, OK",
      "seo_description": "Explore Sugarberry Apartments in Tulsa, OK, featuring a stunning pool and top amenities, perfect for those seeking relaxation and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "generator",
      "page_item_url": "fitness-center-apartment-tulsa-74133",
      "search_query": "fitness center apartment tulsa 74133",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Tulsa 74133",
      "h2_subtitle": "Need a fitness center apartment in Tulsa 74133? Discover Sugarberry Apartments, where wellness meets comfort in a state-of-the-art facility.",
      "page_copy": "Sugarberry Apartments in Tulsa, OK, located in the 74133 zip code, offers a premier fitness center that caters to all your health and wellness needs. Whether you're looking to maintain your routine or start a new fitness journey, our state-of-the-art fitness center is equipped to support you.\n\nOur community doesn't stop at fitness. With a refreshing pool, business center, and pet-friendly amenities, Sugarberry Apartments offers a full spectrum of modern conveniences. Choose from our wide array of floor plans in the lively South Tulsa neighborhood and enjoy the perfect blend of active and comfortable living. Welcome to an energetic lifestyle at Sugarberry Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-aaf6-7079-8f59-92213a43e042.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a fireplace, comfortable sofa, and glass coffee table.",
        "public_id": "019cfb47-aaf6-7079-8f59-92213a43e042",
        "storage_key": "property/6767906449165627/019cfb47-aaf6-7079-8f59-92213a43e042.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Tulsa 74133",
      "seo_description": "Join Sugarberry Apartments in Tulsa 74133, featuring a state-of-the-art fitness center and modern amenities tailored for a comfortable lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "generator",
      "page_item_url": "apartments-with-walking-trails-south-tulsa",
      "search_query": "apartments with walking trails in south tulsa",
      "category": "Amenity",
      "h1_title": "Apartments with Walking Trails in South Tulsa",
      "h2_subtitle": "Explore apartments with walking trails in South Tulsa at Sugarberry Apartments. Enjoy tranquil paths and exceptional amenities in a vibrant community.",
      "page_copy": "Discover Sugarberry Apartments, where tranquility meets convenience with our scenic walking trails nestled in South Tulsa. Perfect for morning jogs or leisurely strolls, our trails offer a breath of fresh air amidst the lush surroundings.\n\nIn addition to picturesque walking trails, our community features a range of exceptional amenities including a sparkling pool, fitness center, and welcoming pet play area. Choose from thoughtfully designed one, two, or three-bedroom floor plans and enjoy all that our vibrant South Tulsa community has to offer. At Sugarberry Apartments, embrace an active lifestyle surrounded by nature's beauty.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-aaf6-7079-8f59-92213a43e042.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a fireplace, comfortable sofa, and glass coffee table.",
        "public_id": "019cfb47-aaf6-7079-8f59-92213a43e042",
        "storage_key": "property/6767906449165627/019cfb47-aaf6-7079-8f59-92213a43e042.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Discover Apartments with Walking Trails in South Tulsa",
      "seo_description": "Find relaxation and activity at Sugarberry Apartments in South Tulsa, featuring serene walking trails and comprehensive amenities for modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-tulsa",
      "search_query": "air conditioned apartments tulsa",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Tulsa",
      "h2_subtitle": "Looking for air conditioned apartments in Tulsa? Sugarberry Apartments offers comfort and modern amenities in a refreshing setting.",
      "page_copy": "At Sugarberry Apartments in Tulsa, we understand the importance of comfort, especially when it comes to battling the Oklahoma heat. Our community offers well-designed air-conditioned apartments that ensure a cool and comfortable environment year-round.\n\nBeyond our climate-controlled interiors, residents can take advantage of our comprehensive range of amenities, which include a sparkling pool, a fully equipped fitness center, and scenic walking trails. Conveniently located in South Tulsa, Sugarberry Apartments provides a retreat from the hustle and bustle, offering a laid-back lifestyle in a vibrant community setting. Experience the ultimate in comfort and convenience at Sugarberry Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-aaf6-7079-8f59-92213a43e042.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a fireplace, comfortable sofa, and glass coffee table.",
        "public_id": "019cfb47-aaf6-7079-8f59-92213a43e042",
        "storage_key": "property/6767906449165627/019cfb47-aaf6-7079-8f59-92213a43e042.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Comfortable Air Conditioned Apartments in Tulsa",
      "seo_description": "Experience ultimate comfort at Sugarberry Apartments in Tulsa, offering air-conditioned living with modern amenities and a welcoming community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-south-tulsa",
      "search_query": "one bedroom apartments in South Tulsa",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in South Tulsa",
      "h2_subtitle": "Discover spacious one bedroom apartments in South Tulsa at Sugarberry Apartments, where comfort meets convenience in a vibrant community.",
      "page_copy": "Welcome to Sugarberry Apartments, where our one bedroom apartments in South Tulsa offer the perfect blend of style and function. Each apartment features modern amenities, ensuring a cozy and efficient living experience. Enjoy the vibrancy of our community while ensuring the comfort of home in our thoughtfully designed one-bedroom layouts.\n\nLocated in the heart of South Tulsa, Sugarberry Apartments not only provides an excellent living space but also offers a plethora of community amenities such as a fitness center, business center, and pet play area. Step outside your apartment and relish the serene walking trails that wind through our picturesque grounds. Make Sugarberry Apartments home and enjoy an unparalleled living experience in South Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-aaf6-7079-8f59-92213a43e042.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a fireplace, comfortable sofa, and glass coffee table.",
        "public_id": "019cfb47-aaf6-7079-8f59-92213a43e042",
        "storage_key": "property/6767906449165627/019cfb47-aaf6-7079-8f59-92213a43e042.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Explore One Bedroom Apartments in South Tulsa",
      "seo_description": "Find your perfect one bedroom apartment at Sugarberry Apartments in South Tulsa, featuring modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-tulsa-ok",
      "search_query": "two bedroom apartments Tulsa OK",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Tulsa, OK",
      "h2_subtitle": "Experience spacious two bedroom apartments in Tulsa, OK at Sugarberry Apartments. Enjoy modern amenities and a vibrant community atmosphere.",
      "page_copy": "Discover the perfect two bedroom apartments in Tulsa, OK at Sugarberry Apartments. Our spacious floor plans are designed to provide ample living space, making them ideal for families, roommates, or anyone seeking extra room. Each apartment boasts modern amenities, ensuring a comfortable and stylish living environment.\n\nAt Sugarberry Apartments, residents can enjoy a variety of community features, including a refreshing pool, a pet-friendly play area, and convenient on-site management. Located in the heart of Tulsa, our two-bedroom apartments offer the perfect balance of tranquility and accessibility, with nearby amenities and easy access to local attractions. Come tour Sugarberry Apartments and find your ideal home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-aaf6-7079-8f59-92213a43e042.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a fireplace, comfortable sofa, and glass coffee table.",
        "public_id": "019cfb47-aaf6-7079-8f59-92213a43e042",
        "storage_key": "property/6767906449165627/019cfb47-aaf6-7079-8f59-92213a43e042.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Tulsa, OK",
      "seo_description": "Discover spacious two bedroom apartments at Sugarberry Apartments in Tulsa, OK. Enjoy modern amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165627",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-74133",
      "search_query": "three bedroom apartments near 74133",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 74133",
      "h2_subtitle": "Explore spacious three bedroom apartments near 74133 at Sugarberry Apartments. Experience comfort and modern living in a thriving community.",
      "page_copy": "Searching for three bedroom apartments near 74133? Sugarberry Apartments in South Tulsa offers spacious options perfect for families, roommates, or anyone looking for extra space. Our three-bedroom layouts feature modern amenities designed to enhance your living experience with comfort and convenience.\n\nLocated conveniently near the 74133 area, Sugarberry Apartments provides easy access to local shopping, dining, and entertainment. Residents can enjoy an array of community amenities, including a refreshing pool and pet-friendly play areas. Our welcoming community and scenic surroundings make Sugarberry Apartments the ideal place to call home. Schedule a visit today and discover the perfect three-bedroom apartment waiting for you!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-aaf6-7079-8f59-92213a43e042.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a fireplace, comfortable sofa, and glass coffee table.",
        "public_id": "019cfb47-aaf6-7079-8f59-92213a43e042",
        "storage_key": "property/6767906449165627/019cfb47-aaf6-7079-8f59-92213a43e042.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near ZIP 74133",
      "seo_description": "Find spacious three bedroom apartments at Sugarberry Apartments near 74133. Enjoy modern amenities and a vibrant community lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5460"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-W7JJ9NDR62"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151861"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/sugarberry-apartments/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-W7CM3JN9"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165627/019d1bd9-cdc0-71cb-921e-d097cbe75b49.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "4fe4a472-e139-43a9-bfa7-d1baa2d7048d"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "855-832-0838"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64651daf5b33aa892ad30776"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InBFdGdUc09aQTN6aXZlVHlsSG9PT3c9PSIsInZhbHVlIjoiNXlnT0dUcndaaWIrQUU3K0lKMWt4UT09IiwibWFjIjoiZjg0ZjRkODM1MjdmMTI4NmY0NGUxZmVhNTk4OWVhNzYwZTRjZmViYzcxMmEwMDNlMzVkZDc3YTEyZjk0MzExZiJ9"
    }
  ],
  "custom_qb_id": "5460",
  "custom_ga4_id": "G-W7JJ9NDR62",
  "custom_repli_id": "10041151861",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/sugarberry-apartments/register/",
  "custom_google_gtm_id": "GTM-W7CM3JN9",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165627/019d1bd9-cdc0-71cb-921e-d097cbe75b49.pdf",
  "custom_rentgrata_property_id": "4fe4a472-e139-43a9-bfa7-d1baa2d7048d",
  "custom_ppc_tracking_phone_number": "855-832-0838",
  "custom_residentboost_apartment_id": "64651daf5b33aa892ad30776",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InBFdGdUc09aQTN6aXZlVHlsSG9PT3c9PSIsInZhbHVlIjoiNXlnT0dUcndaaWIrQUU3K0lKMWt4UT09IiwibWFjIjoiZjg0ZjRkODM1MjdmMTI4NmY0NGUxZmVhNTk4OWVhNzYwZTRjZmViYzcxMmEwMDNlMzVkZDc3YTEyZjk0MzExZiJ9"
};

export const generatedAt = '2026-08-27T21:36:34.914Z';
